import maine_reg from '../../../../../assets/plates/maine/reg1999.png';
import maine_blank from '../../../../../assets/plates/maine/blank1999.png';
import maine_blur from '../../../../../assets/plates/maine/blur1999.png';
import new_hampshire_reg from '../../../../../assets/plates/new_hampshire/reg1999.png';
import new_hampshire_blank from '../../../../../assets/plates/new_hampshire/blank1999.png';
import new_hampshire_blur from '../../../../../assets/plates/new_hampshire/blur1999.png';
import vermont_reg from '../../../../../assets/plates/vermont/reg1990.png';
import vermont_blank from '../../../../../assets/plates/vermont/blank1990.png';
import vermont_blur from '../../../../../assets/plates/vermont/blur1990.png';
import new_york_reg from '../../../../../assets/plates/new_york/reg2020.png';
import new_york_blank from '../../../../../assets/plates/new_york/blank2020.png';
import new_york_blur from '../../../../../assets/plates/new_york/blur2020.png';
import new_york_o0_reg from '../../../../../assets/plates/new_york/reg2010.png';
import new_york_o0_blank from '../../../../../assets/plates/new_york/blank2010.png';
import new_york_o0_blur from '../../../../../assets/plates/new_york/blur2010.png';
import new_york_o1_reg from '../../../../../assets/plates/new_york/reg2001.png';
import new_york_o1_blank from '../../../../../assets/plates/new_york/blank2001.png';
import new_york_o1_blur from '../../../../../assets/plates/new_york/blur2001.png';
import pennsylvania_reg from '../../../../../assets/plates/pennsylvania/reg2004.png';
import pennsylvania_blank from '../../../../../assets/plates/pennsylvania/blank2004.png';
import pennsylvania_blur from '../../../../../assets/plates/pennsylvania/blur2004.png';
import pennsylvania_o0_reg from '../../../../../assets/plates/pennsylvania/reg1999.png';
import pennsylvania_o0_blank from '../../../../../assets/plates/pennsylvania/blank1999.png';
import pennsylvania_o0_blur from '../../../../../assets/plates/pennsylvania/blur1999.png';
import ohio_reg from '../../../../../assets/plates/ohio/reg2021.png';
import ohio_blank from '../../../../../assets/plates/ohio/blank2021.png';
import ohio_blur from '../../../../../assets/plates/ohio/blur2021.png';
import ohio_o0_reg from '../../../../../assets/plates/ohio/reg2013.png';
import ohio_o0_blank from '../../../../../assets/plates/ohio/blank2013.png';
import ohio_o0_blur from '../../../../../assets/plates/ohio/blur2013.png';
import ohio_o1_reg from '../../../../../assets/plates/ohio/reg2009.png';
import ohio_o1_blank from '../../../../../assets/plates/ohio/blank2009.png';
import ohio_o1_blur from '../../../../../assets/plates/ohio/blur2009.png';
import ohio_o2_reg from '../../../../../assets/plates/ohio/reg2004.png';
import ohio_o2_blank from '../../../../../assets/plates/ohio/blank2004.png';
import ohio_o2_blur from '../../../../../assets/plates/ohio/blur2004.png';
import ohio_o3_reg from '../../../../../assets/plates/ohio/reg2001.png';
import ohio_o3_blank from '../../../../../assets/plates/ohio/blank2001.png';
import ohio_o3_blur from '../../../../../assets/plates/ohio/blur2001.png';
import ohio_o4_reg from '../../../../../assets/plates/ohio/reg1997.png';
import ohio_o4_blank from '../../../../../assets/plates/ohio/blank1997.png';
import ohio_o4_blur from '../../../../../assets/plates/ohio/blur1997.png';
import michigan_reg from '../../../../../assets/plates/michigan/reg2013.png';
import michigan_blank from '../../../../../assets/plates/michigan/blank2013.png';
import michigan_blur from '../../../../../assets/plates/michigan/blur2013.png';
import michigan_o0_reg from '../../../../../assets/plates/michigan/reg2007.png';
import michigan_o0_blank from '../../../../../assets/plates/michigan/blank2007.png';
import michigan_o0_blur from '../../../../../assets/plates/michigan/blur2007.png';
import michigan_o1_reg from '../../../../../assets/plates/michigan/reg1983.png';
import michigan_o1_blank from '../../../../../assets/plates/michigan/blank1983.png';
import michigan_o1_blur from '../../../../../assets/plates/michigan/blur1983.png';
import indiana_reg from '../../../../../assets/plates/indiana/reg2017.png';
import indiana_blank from '../../../../../assets/plates/indiana/blank2017.png';
import indiana_blur from '../../../../../assets/plates/indiana/blur2017.png';
import indiana2_reg from '../../../../../assets/plates/indiana/reg2011.png'; // Exception: second currently active plate 
import indiana2_blank from '../../../../../assets/plates/indiana/blank2011.png';
import indiana2_blur from '../../../../../assets/plates/indiana/blur2011.png';
import indiana_o0_reg from '../../../../../assets/plates/indiana/reg2013.png';
import indiana_o0_blank from '../../../../../assets/plates/indiana/blank2013.png';
import indiana_o0_blur from '../../../../../assets/plates/indiana/blur2013.png';
import indiana_o1_reg from '../../../../../assets/plates/indiana/reg2008.png';
import indiana_o1_blank from '../../../../../assets/plates/indiana/blank2008.png';
import indiana_o1_blur from '../../../../../assets/plates/indiana/blur2008.png';
import indiana_o2_reg from '../../../../../assets/plates/indiana/reg2007.png';
import indiana_o2_blank from '../../../../../assets/plates/indiana/blank2007.png';
import indiana_o2_blur from '../../../../../assets/plates/indiana/blur2007.png';

import illinois_reg from '../../../../../assets/plates/illinois/reg2017.png';
import illinois_blank from '../../../../../assets/plates/illinois/blank2017.png';
import illinois_blur from '../../../../../assets/plates/illinois/blur2017.png';
import illinois_o0_reg from '../../../../../assets/plates/illinois/reg2001.png';
import illinois_o0_blank from '../../../../../assets/plates/illinois/blank2001.png';
import illinois_o0_blur from '../../../../../assets/plates/illinois/blur2001.png';
import wisconsin_reg from '../../../../../assets/plates/wisconsin/reg2000.png';
import wisconsin_blank from '../../../../../assets/plates/wisconsin/blank2000.png';
import wisconsin_blur from '../../../../../assets/plates/wisconsin/blur2000.png';
import minnesota_reg from '../../../../../assets/plates/minnesota/reg1987.png';
import minnesota_blank from '../../../../../assets/plates/minnesota/blank1987.png';
import minnesota_blur from '../../../../../assets/plates/minnesota/blur1987.png';
import north_dakota_reg from '../../../../../assets/plates/north_dakota/reg2015.png';
import north_dakota_blank from '../../../../../assets/plates/north_dakota/blank2015.png';
import north_dakota_blur from '../../../../../assets/plates/north_dakota/blur2015.png';
import north_dakota_o0_reg from '../../../../../assets/plates/north_dakota/reg1993.png';
import north_dakota_o0_blank from '../../../../../assets/plates/north_dakota/blank1993.png';
import north_dakota_o0_blur from '../../../../../assets/plates/north_dakota/blur1993.png';
import montana_reg from '../../../../../assets/plates/montana/reg2010.png';
import montana_blank from '../../../../../assets/plates/montana/blank2010.png';
import montana_blur from '../../../../../assets/plates/montana/blur2010.png';
import montana2_reg from '../../../../../assets/plates/montana/reg2006.png'; // Exception: second currently active plate 
import montana2_blank from '../../../../../assets/plates/montana/blank2006.png';
import montana2_blur from '../../../../../assets/plates/montana/blur2006.png';
import montana3_reg from '../../../../../assets/plates/montana/reg2000.png'; // Exception: third currently active plate
import montana3_blank from '../../../../../assets/plates/montana/blank2000.png';
import montana3_blur from '../../../../../assets/plates/montana/blur2000.png';
import montana4_reg from '../../../../../assets/plates/montana/reg1991.png'; // Exception: fourth currently active plate
import montana4_blank from '../../../../../assets/plates/montana/blank1991.png';
import montana4_blur from '../../../../../assets/plates/montana/blur1991.png';
import montana5_reg from '../../../../../assets/plates/montana/reg1989.png'; // Exception: 5th currently active plate
import montana5_blank from '../../../../../assets/plates/montana/blank1989.png';
import montana5_blur from '../../../../../assets/plates/montana/blur1989.png';
import idaho_reg from '../../../../../assets/plates/idaho/reg1991.png';
import idaho_blank from '../../../../../assets/plates/idaho/blank1991.png';
import idaho_blur from '../../../../../assets/plates/idaho/blur1991.png';
import washington_reg from '../../../../../assets/plates/washington/reg1987.png';
import washington_blank from '../../../../../assets/plates/washington/blank1987.png';
import washington_blur from '../../../../../assets/plates/washington/blur1987.png';
import oregon_reg from '../../../../../assets/plates/oregon/reg1989.png';
import oregon_blank from '../../../../../assets/plates/oregon/blank1989.png';
import oregon_blur from '../../../../../assets/plates/oregon/blur1989.png';
import wyoming_reg from '../../../../../assets/plates/wyoming/reg2025.png';
import wyoming_blank from '../../../../../assets/plates/wyoming/blank2025.png';
import wyoming_blur from '../../../../../assets/plates/wyoming/blur2025.png';
import wyoming2_reg from '../../../../../assets/plates/wyoming/reg2016.png'; // Exception: second currently active plate
import wyoming2_blank from '../../../../../assets/plates/wyoming/blank2016.png';
import wyoming2_blur from '../../../../../assets/plates/wyoming/blur2016.png';
import wyoming_o0_reg from '../../../../../assets/plates/wyoming/reg2008.png';
import wyoming_o0_blank from '../../../../../assets/plates/wyoming/blank2008.png';
import wyoming_o0_blur from '../../../../../assets/plates/wyoming/blur2008.png';
import south_dakota_reg from '../../../../../assets/plates/south_dakota/reg2016.png';
import south_dakota_blank from '../../../../../assets/plates/south_dakota/blank2016.png';
import south_dakota_blur from '../../../../../assets/plates/south_dakota/blur2016.png';
import south_dakota_o0_reg from '../../../../../assets/plates/south_dakota/reg2006.png';
import south_dakota_o0_blank from '../../../../../assets/plates/south_dakota/blank2006.png';
import south_dakota_o0_blur from '../../../../../assets/plates/south_dakota/blur2006.png';
import iowa_reg from '../../../../../assets/plates/iowa/reg2018.png';
import iowa_blank from '../../../../../assets/plates/iowa/blank2018.png';
import iowa_blur from '../../../../../assets/plates/iowa/blur2018.png';
import iowa_o0_reg from '../../../../../assets/plates/iowa/reg1997.png';
import iowa_o0_blank from '../../../../../assets/plates/iowa/blank1997.png';
import iowa_o0_blur from '../../../../../assets/plates/iowa/blur1997.png';
import missouri_reg from '../../../../../assets/plates/missouri/reg2018.png';
import missouri_blank from '../../../../../assets/plates/missouri/blank2018.png';
import missouri_blur from '../../../../../assets/plates/missouri/blur2018.png';
import missouri_o0_reg from '../../../../../assets/plates/missouri/reg2008.png';
import missouri_o0_blank from '../../../../../assets/plates/missouri/blank2008.png';
import missouri_o0_blur from '../../../../../assets/plates/missouri/blur2008.png';
import kentucky_reg from '../../../../../assets/plates/kentucky/reg2020.png';
import kentucky_blank from '../../../../../assets/plates/kentucky/blank2020.png';
import kentucky_blur from '../../../../../assets/plates/kentucky/blur2020.png';
import kentucky2_reg from '../../../../../assets/plates/kentucky/reg2020_2.png'; // Exception: second currently active plate
import kentucky2_blank from '../../../../../assets/plates/kentucky/blank2020_2.png';
import kentucky2_blur from '../../../../../assets/plates/kentucky/blur2020_2.png';
import kentucky_o0_reg from '../../../../../assets/plates/kentucky/reg2011.png';
import kentucky_o0_blank from '../../../../../assets/plates/kentucky/blank2011.png';
import kentucky_o0_blur from '../../../../../assets/plates/kentucky/blur2011.png';
import kentucky_o1_reg from '../../../../../assets/plates/kentucky/reg2005.png';
import kentucky_o1_blank from '../../../../../assets/plates/kentucky/blank2005.png';
import kentucky_o1_blur from '../../../../../assets/plates/kentucky/blur2005.png';
import west_virginia_reg from '../../../../../assets/plates/west_virginia/reg1996.png';
import west_virginia_blank from '../../../../../assets/plates/west_virginia/blank1996.png';
import west_virginia_blur from '../../../../../assets/plates/west_virginia/blur1996.png';
import maryland_reg from '../../../../../assets/plates/maryland/reg2016.png';
import maryland_blank from '../../../../../assets/plates/maryland/blank2016.png';
import maryland_blur from '../../../../../assets/plates/maryland/blur2016.png';
import maryland_o0_reg from '../../../../../assets/plates/maryland/reg2012.png';
import maryland_o0_blank from '../../../../../assets/plates/maryland/blank2012.png';
import maryland_o0_blur from '../../../../../assets/plates/maryland/blur2012.png';
import maryland_o1_reg from '../../../../../assets/plates/maryland/reg1987.png';
import maryland_o1_blank from '../../../../../assets/plates/maryland/blank1987.png';
import maryland_o1_blur from '../../../../../assets/plates/maryland/blur1987.png';
import delaware_reg from '../../../../../assets/plates/delaware/reg2008.png';
import delaware_blank from '../../../../../assets/plates/delaware/blank2008.png';
import delaware_blur from '../../../../../assets/plates/delaware/blur2008.png';
import new_jersey_reg from '../../../../../assets/plates/new_jersey/reg1993.png';
import new_jersey_blank from '../../../../../assets/plates/new_jersey/blank1993.png';
import new_jersey_blur from '../../../../../assets/plates/new_jersey/blur1993.png';
import connecticut_reg from '../../../../../assets/plates/connecticut/reg2000.png';
import connecticut_blank from '../../../../../assets/plates/connecticut/blank2000.png';
import connecticut_blur from '../../../../../assets/plates/connecticut/blur2000.png';
import massachusetts_reg from '../../../../../assets/plates/massachusetts/reg1993.png';
import massachusetts_blank from '../../../../../assets/plates/massachusetts/blank1993.png';
import massachusetts_blur from '../../../../../assets/plates/massachusetts/blur1993.png';
import rhode_island_reg from '../../../../../assets/plates/rhode_island/reg1997.png';
import rhode_island_blank from '../../../../../assets/plates/rhode_island/blank1997.png';
import rhode_island_blur from '../../../../../assets/plates/rhode_island/blur1997.png';
import virginia_reg_2006 from '../../../../../assets/plates/virginia/reg2006.png';
import virginia_blank_2006 from '../../../../../assets/plates/virginia/blank2006.png';
import virginia_blur_2006 from '../../../../../assets/plates/virginia/blur2006.png';
import virginia_reg_2008 from '../../../../../assets/plates/virginia/reg2008.png';
import virginia_blank_2008 from '../../../../../assets/plates/virginia/blank2008.png';
import virginia_blur_2008 from '../../../../../assets/plates/virginia/blur2008.png';
import tennessee_reg_2006 from '../../../../../assets/plates/tennessee/reg2006.png';
import tennessee_blank_2006 from '../../../../../assets/plates/tennessee/blank2006.png';
import tennessee_blur_2006 from '../../../../../assets/plates/tennessee/blur2006.png';
import tennessee_reg_2022 from '../../../../../assets/plates/tennessee/reg2022.png';
import tennessee_blank_2022 from '../../../../../assets/plates/tennessee/blank2022.png';
import tennessee_blur_2022 from '../../../../../assets/plates/tennessee/blur2022.png';
import arkansas_reg_2006 from '../../../../../assets/plates/arkansas/reg2006.png';
import arkansas_blank_2006 from '../../../../../assets/plates/arkansas/blank2006.png';
import arkansas_blur_2006 from '../../../../../assets/plates/arkansas/blur2006.png';
import oklahoma_reg_1995 from '../../../../../assets/plates/oklahoma/reg1995.png';
import oklahoma_blank_1995 from '../../../../../assets/plates/oklahoma/blank1995.png';
import oklahoma_blur_1995 from '../../../../../assets/plates/oklahoma/blur1995.png';
import oklahoma_reg_2009 from '../../../../../assets/plates/oklahoma/reg2009.png';
import oklahoma_blank_2009 from '../../../../../assets/plates/oklahoma/blank2009.png';
import oklahoma_blur_2009 from '../../../../../assets/plates/oklahoma/blur2009.png';
import oklahoma_reg_2017 from '../../../../../assets/plates/oklahoma/reg2017.png';
import oklahoma_blank_2017 from '../../../../../assets/plates/oklahoma/blank2017.png';
import oklahoma_blur_2017 from '../../../../../assets/plates/oklahoma/blur2017.png';
import oklahoma_reg_2024 from '../../../../../assets/plates/oklahoma/reg2024.png';
import oklahoma_blank_2024 from '../../../../../assets/plates/oklahoma/blank2024.png';
import oklahoma_blur_2024 from '../../../../../assets/plates/oklahoma/blur2024.png';
import kansas_reg_2001 from '../../../../../assets/plates/kansas/reg2001.png';
import kansas_blank_2001 from '../../../../../assets/plates/kansas/blank2001.png';
import kansas_blur_2001 from '../../../../../assets/plates/kansas/blur2001.png';
import kansas_reg_2007 from '../../../../../assets/plates/kansas/reg2007.png';
import kansas_blank_2007 from '../../../../../assets/plates/kansas/blank2007.png';
import kansas_blur_2007 from '../../../../../assets/plates/kansas/blur2007.png';
import kansas_reg_2024 from '../../../../../assets/plates/kansas/reg2024.png';
import kansas_blank_2024 from '../../../../../assets/plates/kansas/blank2024.png';
import kansas_blur_2024 from '../../../../../assets/plates/kansas/blur2024.png';
import nebraska_reg_2002 from '../../../../../assets/plates/nebraska/reg2002.png';
import nebraska_blank_2002 from '../../../../../assets/plates/nebraska/blank2002.png';
import nebraska_blur_2002 from '../../../../../assets/plates/nebraska/blur2002.png';
import nebraska_reg_2005 from '../../../../../assets/plates/nebraska/reg2005.png';
import nebraska_blank_2005 from '../../../../../assets/plates/nebraska/blank2005.png';
import nebraska_blur_2005 from '../../../../../assets/plates/nebraska/blur2005.png';
import nebraska_reg_2011 from '../../../../../assets/plates/nebraska/reg2011.png';
import nebraska_blank_2011 from '../../../../../assets/plates/nebraska/blank2011.png';
import nebraska_blur_2011 from '../../../../../assets/plates/nebraska/blur2011.png';
import nebraska_reg_2017 from '../../../../../assets/plates/nebraska/reg2017.png';
import nebraska_blank_2017 from '../../../../../assets/plates/nebraska/blank2017.png';
import nebraska_blur_2017 from '../../../../../assets/plates/nebraska/blur2017.png';
import nebraska_reg_2023 from '../../../../../assets/plates/nebraska/reg2023.png';
import nebraska_blank_2023 from '../../../../../assets/plates/nebraska/blank2023.png';
import nebraska_blur_2023 from '../../../../../assets/plates/nebraska/blur2023.png';
import colorado_reg_2000 from '../../../../../assets/plates/colorado/reg2000.png';
import colorado_blank_2000 from '../../../../../assets/plates/colorado/blank2000.png';
import colorado_blur_2000 from '../../../../../assets/plates/colorado/blur2000.png';

import utah_reg from '../../../../../assets/plates/utah/reg2008.png';
import utah_blank from '../../../../../assets/plates/utah/blank2008.png';
import utah_blur from '../../../../../assets/plates/utah/blur2008.png';
import utah2_reg from '../../../../../assets/plates/utah/reg2009.png'; // Exception: second currently active plate 
import utah2_blank from '../../../../../assets/plates/utah/blank2009.png';
import utah2_blur from '../../../../../assets/plates/utah/blur2009.png';
import utah3_reg from '../../../../../assets/plates/utah/reg2017.png'; // Exception: third currently active plate 
import utah3_blank from '../../../../../assets/plates/utah/blank2017.png';
import utah3_blur from '../../../../../assets/plates/utah/blur2017.png';
import nevada_reg from '../../../../../assets/plates/nevada/reg2017.png';
import nevada_blank from '../../../../../assets/plates/nevada/blank2017.png';
import nevada_blur from '../../../../../assets/plates/nevada/blur2017.png';
import nevada_o0_reg from '../../../../../assets/plates/nevada/reg2006.png';
import nevada_o0_blank from '../../../../../assets/plates/nevada/blank2006.png';
import nevada_o0_blur from '../../../../../assets/plates/nevada/blur2006.png';
import california_reg from '../../../../../assets/plates/california/reg1993.png';
import california_blank from '../../../../../assets/plates/california/blank1993.png';
import california_blur from '../../../../../assets/plates/california/blur1993.png';
import arizona_reg from '../../../../../assets/plates/arizona/reg1997.png';
import arizona_blank from '../../../../../assets/plates/arizona/blank1997.png';
import arizona_blur from '../../../../../assets/plates/arizona/blur1997.png';
import new_mexico_reg from '../../../../../assets/plates/new_mexico/reg1991.png';
import new_mexico_blank from '../../../../../assets/plates/new_mexico/blank1991.png';
import new_mexico_blur from '../../../../../assets/plates/new_mexico/blur1991.png';
import new_mexico2_reg from '../../../../../assets/plates/new_mexico/reg2010.png'; // Exception: second currently active plate
import new_mexico2_blank from '../../../../../assets/plates/new_mexico/blank2010.png';
import new_mexico2_blur from '../../../../../assets/plates/new_mexico/blur2010.png';
import new_mexico3_reg from '../../../../../assets/plates/new_mexico/reg2017.png'; // Exception: third currently active plate
import new_mexico3_blank from '../../../../../assets/plates/new_mexico/blank2017.png';
import new_mexico3_blur from '../../../../../assets/plates/new_mexico/blur2017.png';
import new_mexico_o0_reg from '../../../../../assets/plates/new_mexico/reg1999.png';
import new_mexico_o0_blank from '../../../../../assets/plates/new_mexico/blank1999.png';
import new_mexico_o0_blur from '../../../../../assets/plates/new_mexico/blur1999.png';
import texas_reg from '../../../../../assets/plates/texas/reg2012.png';
import texas_blank from '../../../../../assets/plates/texas/blank2012.png';
import texas_blur from '../../../../../assets/plates/texas/blur2012.png';
import texas_o0_reg from '../../../../../assets/plates/texas/reg2011.png';
import texas_o0_blank from '../../../../../assets/plates/texas/blank2011.png';
import texas_o0_blur from '../../../../../assets/plates/texas/blur2011.png';
import texas_o1_reg from '../../../../../assets/plates/texas/reg2009.png';
import texas_o1_blank from '../../../../../assets/plates/texas/blank2009.png';
import texas_o1_blur from '../../../../../assets/plates/texas/blur2009.png';
import texas_o2_reg from '../../../../../assets/plates/texas/reg1999.png';
import texas_o2_blank from '../../../../../assets/plates/texas/blank1999.png';
import texas_o2_blur from '../../../../../assets/plates/texas/blur1999.png';
import district_of_columbia_reg from '../../../../../assets/plates/district_of_columbia/reg1998.png';
import district_of_columbia_blank from '../../../../../assets/plates/district_of_columbia/blank1998.png';
import district_of_columbia_blur from '../../../../../assets/plates/district_of_columbia/blur1998.png';
import louisiana_reg from '../../../../../assets/plates/louisiana/reg2016.png';
import louisiana_blank from '../../../../../assets/plates/louisiana/blank2016.png';
import louisiana_blur from '../../../../../assets/plates/louisiana/blur2016.png';
import louisiana_o0_reg from '../../../../../assets/plates/louisiana/reg2014.png';
import louisiana_o0_blank from '../../../../../assets/plates/louisiana/blank2014.png';
import louisiana_o0_blur from '../../../../../assets/plates/louisiana/blur2014.png';
import louisiana_o1_reg from '../../../../../assets/plates/louisiana/reg2011.png';
import louisiana_o1_blank from '../../../../../assets/plates/louisiana/blank2011.png';
import louisiana_o1_blur from '../../../../../assets/plates/louisiana/blur2011.png';
import mississippi_reg from '../../../../../assets/plates/mississippi/reg2024.png';
import mississippi_blank from '../../../../../assets/plates/mississippi/blank2024.png';
import mississippi_blur from '../../../../../assets/plates/mississippi/blur2024.png';
import mississippi_o0_reg from '../../../../../assets/plates/mississippi/reg2019.png';
import mississippi_o0_blank from '../../../../../assets/plates/mississippi/blank2019.png';
import mississippi_o0_blur from '../../../../../assets/plates/mississippi/blur2019.png';
import mississippi_o1_reg from '../../../../../assets/plates/mississippi/reg2012.png';
import mississippi_o1_blank from '../../../../../assets/plates/mississippi/blank2012.png';
import mississippi_o1_blur from '../../../../../assets/plates/mississippi/blur2012.png';
import mississippi_o2_reg from '../../../../../assets/plates/mississippi/reg2009.png';
import mississippi_o2_blank from '../../../../../assets/plates/mississippi/blank2009.png';
import mississippi_o2_blur from '../../../../../assets/plates/mississippi/blur2009.png';
import mississippi_o3_reg from '../../../../../assets/plates/mississippi/reg2003.png';
import mississippi_o3_blank from '../../../../../assets/plates/mississippi/blank2003.png';
import mississippi_o3_blur from '../../../../../assets/plates/mississippi/blur2003.png';
import alabama_reg from '../../../../../assets/plates/alabama/reg2022.png';
import alabama_blank from '../../../../../assets/plates/alabama/blank2022.png';
import alabama_blur from '../../../../../assets/plates/alabama/blur2022.png';
import alabama2_reg from '../../../../../assets/plates/alabama/reg2013.png'; // Exception: second currently active plate
import alabama2_blank from '../../../../../assets/plates/alabama/blank2013.png';
import alabama2_blur from '../../../../../assets/plates/alabama/blur2013.png';
import alabama_o0_reg from '../../../../../assets/plates/alabama/reg2014.png';
import alabama_o0_blank from '../../../../../assets/plates/alabama/blank2014.png';
import alabama_o0_blur from '../../../../../assets/plates/alabama/blur2014.png';
import alabama_o1_reg from '../../../../../assets/plates/alabama/reg2009.png';
import alabama_o1_blank from '../../../../../assets/plates/alabama/blank2009.png';
import alabama_o1_blur from '../../../../../assets/plates/alabama/blur2009.png';
import alabama_o2_reg from '../../../../../assets/plates/alabama/reg2002.png';
import alabama_o2_blank from '../../../../../assets/plates/alabama/blank2002.png';
import alabama_o2_blur from '../../../../../assets/plates/alabama/blur2002.png';
import alabama2_o2_reg from '../../../../../assets/plates/alabama/reg2007.png'; // Exception: second overlapping old plate
import alabama2_o2_blank from '../../../../../assets/plates/alabama/blank2007.png';
import alabama2_o2_blur from '../../../../../assets/plates/alabama/blur2007.png';
import georgia_reg from '../../../../../assets/plates/georgia/reg2012.png';
import georgia_blank from '../../../../../assets/plates/georgia/blank2012.png';
import georgia_blur from '../../../../../assets/plates/georgia/blur2012.png';
import georgia2_reg from '../../../../../assets/plates/georgia/reg2012_2.png'; // Exception: second currently active plate
import georgia2_blank from '../../../../../assets/plates/georgia/blank2012_2.png';
import georgia2_blur from '../../../../../assets/plates/georgia/blur2012_2.png';
import south_carolina_reg from '../../../../../assets/plates/south_carolina/reg2016.png';
import south_carolina_blank from '../../../../../assets/plates/south_carolina/blank2016.png';
import south_carolina_blur from '../../../../../assets/plates/south_carolina/blur2016.png';
import south_carolina2_reg from '../../../../../assets/plates/south_carolina/reg2016_2.png'; // Exception: second currently active plate
import south_carolina2_blank from '../../../../../assets/plates/south_carolina/blank2016_2.png';
import south_carolina2_blur from '../../../../../assets/plates/south_carolina/blur2016_2.png';
import south_carolina_o0_reg from '../../../../../assets/plates/south_carolina/reg2008.png';
import south_carolina_o0_blank from '../../../../../assets/plates/south_carolina/blank2008.png';
import south_carolina_o0_blur from '../../../../../assets/plates/south_carolina/blur2008.png';
import south_carolina_o1_reg from '../../../../../assets/plates/south_carolina/reg1999.png';
import south_carolina_o1_blank from '../../../../../assets/plates/south_carolina/blank1999.png';
import south_carolina_o1_blur from '../../../../../assets/plates/south_carolina/blur1999.png';
import south_carolina2_o1_reg from '../../../../../assets/plates/south_carolina/reg2003.png'; // Exception: second overlapping old plate
import south_carolina2_o1_blank from '../../../../../assets/plates/south_carolina/blank2003.png';
import south_carolina2_o1_blur from '../../../../../assets/plates/south_carolina/blur2003.png';
import north_carolina_reg from '../../../../../assets/plates/north_carolina/reg2009.png';
import north_carolina_blank from '../../../../../assets/plates/north_carolina/blank2009.png';
import north_carolina_blur from '../../../../../assets/plates/north_carolina/blur2009.png';
import north_carolina2_reg from '../../../../../assets/plates/north_carolina/reg2015.png'; // Exception: second currently active plate
import north_carolina2_blank from '../../../../../assets/plates/north_carolina/blank2015.png';
import north_carolina2_blur from '../../../../../assets/plates/north_carolina/blur2015.png';
import north_carolina3_reg from '../../../../../assets/plates/north_carolina/reg2019.png'; // Exception: third currently active plate
import north_carolina3_blank from '../../../../../assets/plates/north_carolina/blank2019.png';
import north_carolina3_blur from '../../../../../assets/plates/north_carolina/blur2019.png';
import north_carolina_o0_reg from '../../../../../assets/plates/north_carolina/reg2007.png';
import north_carolina_o0_blank from '../../../../../assets/plates/north_carolina/blank2007.png';
import north_carolina_o0_blur from '../../../../../assets/plates/north_carolina/blur2007.png';
import florida_reg from '../../../../../assets/plates/florida/reg2003.png';
import florida_blank from '../../../../../assets/plates/florida/blank2003.png';
import florida_blur from '../../../../../assets/plates/florida/blur2003.png';
import alaska_reg from '../../../../../assets/plates/alaska/reg1981.png';
import alaska_blank from '../../../../../assets/plates/alaska/blank1981.png';
import alaska_blur from '../../../../../assets/plates/alaska/blur1981.png';
import alaska2_reg from '../../../../../assets/plates/alaska/reg2015.png'; // Exception: second currently active plate
import alaska2_blank from '../../../../../assets/plates/alaska/blank2015.png';
import alaska2_blur from '../../../../../assets/plates/alaska/blur2015.png';
import alaska3_reg from '../../../../../assets/plates/alaska/reg2019.png'; // Exception: third currently active plate
import alaska3_blank from '../../../../../assets/plates/alaska/blank2019.png';
import alaska3_blur from '../../../../../assets/plates/alaska/blur2019.png';
import alaska_o0_reg from '../../../../../assets/plates/alaska/reg2008.png';
import alaska_o0_blank from '../../../../../assets/plates/alaska/blank2008.png';
import alaska_o0_blur from '../../../../../assets/plates/alaska/blur2008.png';
import hawaii_reg from '../../../../../assets/plates/hawaii/reg1991.png';
import hawaii_blank from '../../../../../assets/plates/hawaii/blank1991.png';
import hawaii_blur from '../../../../../assets/plates/hawaii/blur1991.png';

/* U.S. Territories */
import puerto_rico_reg from '../../../../../assets/plates/us_territories/puerto_rico/reg1987.png';
import puerto_rico_blank from '../../../../../assets/plates/us_territories/puerto_rico/blank1987.png';
import puerto_rico_blur from '../../../../../assets/plates/us_territories/puerto_rico/blur1987.png';
import puerto_rico2_reg from '../../../../../assets/plates/us_territories/puerto_rico/reg2007.png'; // Exception: second currently active plate
import puerto_rico2_blank from '../../../../../assets/plates/us_territories/puerto_rico/blank2007.png';
import puerto_rico2_blur from '../../../../../assets/plates/us_territories/puerto_rico/blur2007.png';
import american_samoa_reg from '../../../../../assets/plates/us_territories/american_samoa/reg2011.png';
import american_samoa_blank from '../../../../../assets/plates/us_territories/american_samoa/blank2011.png';
import american_samoa_blur from '../../../../../assets/plates/us_territories/american_samoa/blur2011.png';
import guam_reg from '../../../../../assets/plates/us_territories/guam/reg2009.png';
import guam_blank from '../../../../../assets/plates/us_territories/guam/blank2009.png';
import guam_blur from '../../../../../assets/plates/us_territories/guam/blur2009.png';
import northern_mariana_islands_reg from '../../../../../assets/plates/us_territories/northern_mariana_islands/reg2005.png';
import northern_mariana_islands_blank from '../../../../../assets/plates/us_territories/northern_mariana_islands/blank2005.png';
import northern_mariana_islands_blur from '../../../../../assets/plates/us_territories/northern_mariana_islands/blur2005.png';
import us_virgin_islands_reg from '../../../../../assets/plates/us_territories/us_virgin_islands/reg2016.png';
import us_virgin_islands_blank from '../../../../../assets/plates/us_territories/us_virgin_islands/blank2016.png';
import us_virgin_islands_blur from '../../../../../assets/plates/us_territories/us_virgin_islands/blur2016.png';
import us_virgin_islands_o0_reg from '../../../../../assets/plates/us_territories/us_virgin_islands/reg2006.png';
import us_virgin_islands_o0_blank from '../../../../../assets/plates/us_territories/us_virgin_islands/blank2006.png';
import us_virgin_islands_o0_blur from '../../../../../assets/plates/us_territories/us_virgin_islands/blur2006.png';

/* Canada */
import british_columbia_reg from '../../../../../assets/plates/canada/british_columbia/reg1986.png';
import british_columbia_blank from '../../../../../assets/plates/canada/british_columbia/blank1986.png';
import british_columbia_blur from '../../../../../assets/plates/canada/british_columbia/blur1986.png';
import yukon_reg from '../../../../../assets/plates/canada/yukon/reg1990.png';
import yukon_blank from '../../../../../assets/plates/canada/yukon/blank1990.png';
import yukon_blur from '../../../../../assets/plates/canada/yukon/blur1990.png';
import alberta_reg from '../../../../../assets/plates/canada/alberta/reg1984.png';
import alberta_blank from '../../../../../assets/plates/canada/alberta/blank1984.png';
import alberta_blur from '../../../../../assets/plates/canada/alberta/blur1984.png';
import northwest_territories_reg from '../../../../../assets/plates/canada/northwest_territories/reg2010.png';
import northwest_territories_blank from '../../../../../assets/plates/canada/northwest_territories/blank2010.png';
import northwest_territories_blur from '../../../../../assets/plates/canada/northwest_territories/blur2010.png';
import northwest_territories_o0_reg from '../../../../../assets/plates/canada/northwest_territories/reg1986.png';
import northwest_territories_o0_blank from '../../../../../assets/plates/canada/northwest_territories/blank1986.png';
import northwest_territories_o0_blur from '../../../../../assets/plates/canada/northwest_territories/blur1986.png';
import nunavut_reg from '../../../../../assets/plates/canada/nunavut/reg2012.png';
import nunavut_blank from '../../../../../assets/plates/canada/nunavut/blank2012.png';
import nunavut_blur from '../../../../../assets/plates/canada/nunavut/blur2012.png';
import nunavut_o0_reg from '../../../../../assets/plates/canada/nunavut/reg2000.png';
import nunavut_o0_blank from '../../../../../assets/plates/canada/nunavut/blank2000.png';
import nunavut_o0_blur from '../../../../../assets/plates/canada/nunavut/blur2000.png';
import saskatchewan_reg from '../../../../../assets/plates/canada/saskatchewan/reg2009.png';
import saskatchewan_blank from '../../../../../assets/plates/canada/saskatchewan/blank2009.png';
import saskatchewan_blur from '../../../../../assets/plates/canada/saskatchewan/blur2009.png';
import manitoba_reg from '../../../../../assets/plates/canada/manitoba/reg1997.png';
import manitoba_blank from '../../../../../assets/plates/canada/manitoba/blank1997.png';
import manitoba_blur from '../../../../../assets/plates/canada/manitoba/blur1997.png';
import ontario_reg from '../../../../../assets/plates/canada/ontario/reg1996.png';
import ontario_blank from '../../../../../assets/plates/canada/ontario/blank1996.png';
import ontario_blur from '../../../../../assets/plates/canada/ontario/blur1996.png';
import ontario_o0_reg from '../../../../../assets/plates/canada/ontario/reg2023.png';
import ontario_o0_blank from '../../../../../assets/plates/canada/ontario/blank2023.png';
import ontario_o0_blur from '../../../../../assets/plates/canada/ontario/blur2023.png';
import quebec_reg from '../../../../../assets/plates/canada/quebec/reg1983.png';
import quebec_blank from '../../../../../assets/plates/canada/quebec/blank1983.png';
import quebec_blur from '../../../../../assets/plates/canada/quebec/blur1983.png';
import new_brunswick_reg from '../../../../../assets/plates/canada/new_brunswick/reg2011.png';
import new_brunswick_blank from '../../../../../assets/plates/canada/new_brunswick/blank2011.png';
import new_brunswick_blur from '../../../../../assets/plates/canada/new_brunswick/blur2011.png';
import new_brunswick_o0_reg from '../../../../../assets/plates/canada/new_brunswick/reg1992.png';
import new_brunswick_o0_blank from '../../../../../assets/plates/canada/new_brunswick/blank1992.png';
import new_brunswick_o0_blur from '../../../../../assets/plates/canada/new_brunswick/blur1992.png';
import nova_scotia_reg from '../../../../../assets/plates/canada/nova_scotia/reg2012.png';
import nova_scotia_blank from '../../../../../assets/plates/canada/nova_scotia/blank2012.png';
import nova_scotia_blur from '../../../../../assets/plates/canada/nova_scotia/blur2012.png';
import newfoundland_and_labrador_reg from '../../../../../assets/plates/canada/newfoundland_and_labrador/reg2022.png';
import newfoundland_and_labrador_blank from '../../../../../assets/plates/canada/newfoundland_and_labrador/blank2022.png';
import newfoundland_and_labrador_blur from '../../../../../assets/plates/canada/newfoundland_and_labrador/blur2022.png';
import newfoundland_and_labrador_o0_reg from '../../../../../assets/plates/canada/newfoundland_and_labrador/reg2008.png';
import newfoundland_and_labrador_o0_blank from '../../../../../assets/plates/canada/newfoundland_and_labrador/blank2008.png';
import newfoundland_and_labrador_o0_blur from '../../../../../assets/plates/canada/newfoundland_and_labrador/blur2008.png';
import newfoundland_and_labrador_o1_reg from '../../../../../assets/plates/canada/newfoundland_and_labrador/reg2004.png';
import newfoundland_and_labrador_o1_blank from '../../../../../assets/plates/canada/newfoundland_and_labrador/blank2004.png';
import newfoundland_and_labrador_o1_blur from '../../../../../assets/plates/canada/newfoundland_and_labrador/blur2004.png';
import prince_edward_island_reg from '../../../../../assets/plates/canada/prince_edward_island/reg2022.png';
import prince_edward_island_blank from '../../../../../assets/plates/canada/prince_edward_island/blank2022.png';
import prince_edward_island_blur from '../../../../../assets/plates/canada/prince_edward_island/blur2022.png';
import prince_edward_island_o0_reg from '../../../../../assets/plates/canada/prince_edward_island/reg2013.png';
import prince_edward_island_o0_blank from '../../../../../assets/plates/canada/prince_edward_island/blank2013.png';
import prince_edward_island_o0_blur from '../../../../../assets/plates/canada/prince_edward_island/blur2013.png';
import prince_edward_island_o1_reg from '../../../../../assets/plates/canada/prince_edward_island/reg2007.png';
import prince_edward_island_o1_blank from '../../../../../assets/plates/canada/prince_edward_island/blank2007.png';
import prince_edward_island_o1_blur from '../../../../../assets/plates/canada/prince_edward_island/blur2007.png';
import prince_edward_island_o2_reg from '../../../../../assets/plates/canada/prince_edward_island/reg1997.png';
import prince_edward_island_o2_blank from '../../../../../assets/plates/canada/prince_edward_island/blank1997.png';
import prince_edward_island_o2_blur from '../../../../../assets/plates/canada/prince_edward_island/blur1997.png';

/* Special plates */
import kentucky_sp0_reg from '../../../../../assets/plates/kentucky/sp0_reg2023.png';
import kentucky_sp0_blank from '../../../../../assets/plates/kentucky/sp0_blank2023.png';
import kentucky_sp0_blur from '../../../../../assets/plates/kentucky/sp0_blur2023.png';
import california_sp0_reg from '../../../../../assets/plates/california/sp0_reg2015.png';
import california_sp0_blank from '../../../../../assets/plates/california/sp0_blank2015.png';
import california_sp0_blur from '../../../../../assets/plates/california/sp0_blur2015.png';

import california_sp1_reg from '../../../../../assets/plates/_us_special/california/reg2006.png';
import california_sp1_blank from '../../../../../assets/plates/_us_special/california/blank2006.png';
import california_sp1_blur from '../../../../../assets/plates/_us_special/california/blur2006.png';
import washington_sp0_reg from '../../../../../assets/plates/_us_special/washington/reg2012.png';
import washington_sp0_blank from '../../../../../assets/plates/_us_special/washington/blank2012.png';
import washington_sp0_blur from '../../../../../assets/plates/_us_special/washington/blur2012.png';
import oregon_sp0_reg from '../../../../../assets/plates/_us_special/oregon/reg2002.png';
import oregon_sp0_blank from '../../../../../assets/plates/_us_special/oregon/blank2002.png';
import oregon_sp0_blur from '../../../../../assets/plates/_us_special/oregon/blur2002.png';
import oregon_sp1_reg from '../../../../../assets/plates/_us_special/oregon/reg2022.png';
import oregon_sp1_blank from '../../../../../assets/plates/_us_special/oregon/blank2022.png';
import oregon_sp1_blur from '../../../../../assets/plates/_us_special/oregon/blur2022.png';
import nevada_sp0_reg from '../../../../../assets/plates/_us_special/nevada/reg2013.png';
import nevada_sp0_blank from '../../../../../assets/plates/_us_special/nevada/blank2013.png';
import nevada_sp0_blur from '../../../../../assets/plates/_us_special/nevada/blur2013.png';
import nevada_sp1_reg from '../../../../../assets/plates/_us_special/nevada/reg2015.png';
import nevada_sp1_blank from '../../../../../assets/plates/_us_special/nevada/blank2015.png';
import nevada_sp1_blur from '../../../../../assets/plates/_us_special/nevada/blur2015.png';
import arizona_sp0_reg from '../../../../../assets/plates/_us_special/arizona/reg2021.png';
import arizona_sp0_blank from '../../../../../assets/plates/_us_special/arizona/blank2021.png';
import arizona_sp0_blur from '../../../../../assets/plates/_us_special/arizona/blur2021.png';
import colorado_sp0_reg from '../../../../../assets/plates/_us_special/colorado/reg2001.png';
import colorado_sp0_blank from '../../../../../assets/plates/_us_special/colorado/blank2001.png';
import colorado_sp0_blur from '../../../../../assets/plates/_us_special/colorado/blur2001.png';
import colorado_sp1_reg from '../../../../../assets/plates/_us_special/colorado/reg2022.png';
import colorado_sp1_blank from '../../../../../assets/plates/_us_special/colorado/blank2022.png';
import colorado_sp1_blur from '../../../../../assets/plates/_us_special/colorado/blur2022.png';
import colorado_sp2_reg from '../../../../../assets/plates/_us_special/colorado/reg2000.png';
import colorado_sp2_blank from '../../../../../assets/plates/_us_special/colorado/blank2000.png';
import colorado_sp2_blur from '../../../../../assets/plates/_us_special/colorado/blur2000.png';
import nebraska_sp0_reg from '../../../../../assets/plates/_us_special/nebraska/reg2016.png';
import nebraska_sp0_blank from '../../../../../assets/plates/_us_special/nebraska/blank2016.png';
import nebraska_sp0_blur from '../../../../../assets/plates/_us_special/nebraska/blur2016.png';
import oklahoma_sp0_reg from '../../../../../assets/plates/_us_special/oklahoma/reg2008.png';
import oklahoma_sp0_blank from '../../../../../assets/plates/_us_special/oklahoma/blank2008.png';
import oklahoma_sp0_blur from '../../../../../assets/plates/_us_special/oklahoma/blur2008.png';
import texas_sp0_reg from '../../../../../assets/plates/_us_special/texas/reg2016.png';
import texas_sp0_blank from '../../../../../assets/plates/_us_special/texas/blank2016.png';
import texas_sp0_blur from '../../../../../assets/plates/_us_special/texas/blur2016.png';
import minnesota_sp0_reg from '../../../../../assets/plates/_us_special/minnesota/reg2024.png';
import minnesota_sp0_blank from '../../../../../assets/plates/_us_special/minnesota/blank2024.png';
import minnesota_sp0_blur from '../../../../../assets/plates/_us_special/minnesota/blur2024.png';
import iowa_sp0_reg from '../../../../../assets/plates/_us_special/iowa/reg2019.png';
import iowa_sp0_blank from '../../../../../assets/plates/_us_special/iowa/blank2019.png';
import iowa_sp0_blur from '../../../../../assets/plates/_us_special/iowa/blur2019.png';
import arkansas_sp0_reg from '../../../../../assets/plates/_us_special/arkansas/reg1994.png';
import arkansas_sp0_blank from '../../../../../assets/plates/_us_special/arkansas/blank1994.png';
import arkansas_sp0_blur from '../../../../../assets/plates/_us_special/arkansas/blur1994.png';
import louisiana_sp0_reg from '../../../../../assets/plates/_us_special/louisiana/reg1992.png';
import louisiana_sp0_blank from '../../../../../assets/plates/_us_special/louisiana/blank1992.png';
import louisiana_sp0_blur from '../../../../../assets/plates/_us_special/louisiana/blur1992.png';
import louisiana_sp1_reg from '../../../../../assets/plates/_us_special/louisiana/reg2010.png';
import louisiana_sp1_blank from '../../../../../assets/plates/_us_special/louisiana/blank2010.png';
import louisiana_sp1_blur from '../../../../../assets/plates/_us_special/louisiana/blur2010.png';
import louisiana_sp2_reg from '../../../../../assets/plates/_us_special/louisiana/reg2019.png';
import louisiana_sp2_blank from '../../../../../assets/plates/_us_special/louisiana/blank2019.png';
import louisiana_sp2_blur from '../../../../../assets/plates/_us_special/louisiana/blur2019.png';
import kentucky_sp1_reg from '../../../../../assets/plates/_us_special/kentucky/reg2009.png';
import kentucky_sp1_blank from '../../../../../assets/plates/_us_special/kentucky/blank2009.png';
import kentucky_sp1_blur from '../../../../../assets/plates/_us_special/kentucky/blur2009.png';
import tennessee_sp0_reg from '../../../../../assets/plates/_us_special/tennessee/reg2017.png';
import tennessee_sp0_blank from '../../../../../assets/plates/_us_special/tennessee/blank2017.png';
import tennessee_sp0_blur from '../../../../../assets/plates/_us_special/tennessee/blur2017.png';
import michigan_sp0_reg from '../../../../../assets/plates/_us_special/michigan/reg1965.png';
import michigan_sp0_blank from '../../../../../assets/plates/_us_special/michigan/blank1965.png';
import michigan_sp0_blur from '../../../../../assets/plates/_us_special/michigan/blur1965.png';
import michigan_sp1_reg from '../../../../../assets/plates/_us_special/michigan/reg2013.png';
import michigan_sp1_blank from '../../../../../assets/plates/_us_special/michigan/blank2013.png';
import michigan_sp1_blur from '../../../../../assets/plates/_us_special/michigan/blur2013.png';
import indiana_sp0_reg from '../../../../../assets/plates/_us_special/indiana/reg1991.png';
import indiana_sp0_blank from '../../../../../assets/plates/_us_special/indiana/blank1991.png';
import indiana_sp0_blur from '../../../../../assets/plates/_us_special/indiana/blur1991.png';
import indiana_sp1_reg from '../../../../../assets/plates/_us_special/indiana/reg2007.png';
import indiana_sp1_blank from '../../../../../assets/plates/_us_special/indiana/blank2007.png';
import indiana_sp1_blur from '../../../../../assets/plates/_us_special/indiana/blur2007.png';
import alabama_sp0_reg from '../../../../../assets/plates/_us_special/alabama/reg2020.png';
import alabama_sp0_blank from '../../../../../assets/plates/_us_special/alabama/blank2020.png';
import alabama_sp0_blur from '../../../../../assets/plates/_us_special/alabama/blur2020.png';
import alabama_sp1_reg from '../../../../../assets/plates/_us_special/alabama/reg2015.png';
import alabama_sp1_blank from '../../../../../assets/plates/_us_special/alabama/blank2015.png';
import alabama_sp1_blur from '../../../../../assets/plates/_us_special/alabama/blur2015.png';
import ohio_sp0_reg from '../../../../../assets/plates/_us_special/ohio/reg2023.png';
import ohio_sp0_blank from '../../../../../assets/plates/_us_special/ohio/blank2023.png';
import ohio_sp0_blur from '../../../../../assets/plates/_us_special/ohio/blur2023.png';
import maryland_sp0_reg from '../../../../../assets/plates/_us_special/maryland/reg2018.png';
import maryland_sp0_blank from '../../../../../assets/plates/_us_special/maryland/blank2018.png';
import maryland_sp0_blur from '../../../../../assets/plates/_us_special/maryland/blur2018.png';
import virginia_sp0_reg from '../../../../../assets/plates/_us_special/virginia/reg1992.png';
import virginia_sp0_blank from '../../../../../assets/plates/_us_special/virginia/blank1992.png';
import virginia_sp0_blur from '../../../../../assets/plates/_us_special/virginia/blur1992.png';
import florida_sp0_reg from '../../../../../assets/plates/_us_special/florida/reg1998.png';
import florida_sp0_blank from '../../../../../assets/plates/_us_special/florida/blank1998.png';
import florida_sp0_blur from '../../../../../assets/plates/_us_special/florida/blur1998.png';
import florida_sp1_reg from '../../../../../assets/plates/_us_special/florida/reg2010.png';
import florida_sp1_blank from '../../../../../assets/plates/_us_special/florida/blank2010.png';
import florida_sp1_blur from '../../../../../assets/plates/_us_special/florida/blur2010.png';
import massachusetts_sp0_reg from '../../../../../assets/plates/_us_special/massachusetts/reg1996.png';
import massachusetts_sp0_blank from '../../../../../assets/plates/_us_special/massachusetts/blank1996.png';
import massachusetts_sp0_blur from '../../../../../assets/plates/_us_special/massachusetts/blur1996.png';
import new_jersey_sp0_reg from '../../../../../assets/plates/_us_special/new_jersey/reg2016.png';
import new_jersey_sp0_blank from '../../../../../assets/plates/_us_special/new_jersey/blank2016.png';
import new_jersey_sp0_blur from '../../../../../assets/plates/_us_special/new_jersey/blur2016.png';
// To add:
// Washington State University
// Crater Lake
// Idaho wildlife programs
// Las Vegas Commemorative Plate
// AZ: First Responder, Veterans
// Colorado: Columbine, Blackout
// NE: mountain lion conservation plate
// OK: In God We Trust
// TX: Classic black
// Minnesota: blackout
// Iowa: blackout
// arkansas razorback plate
// Louisiana: Saints, LSU
// Kentucky: Friends of Coal
// TN: Don't Tread On Me
// Michigan: mackinac bridge, winter wonderland
// Indiana: IU, Purdue
// University of Alabama, Auburn 
// Ohio: OSU
// Chesapeake Bay plate
// Scenic Virginia
// USC
// Fl: Endless summer, helping sea turtles, UF
// Cape cod and islands
// Shore to Please


/* Mexico */
import aguascalientes_reg from '../../../../../assets/plates/mexico/aguascalientes/reg2023.png';
import aguascalientes_blank from '../../../../../assets/plates/mexico/aguascalientes/blank2023.png';
import aguascalientes_blur from '../../../../../assets/plates/mexico/aguascalientes/blur2023.png';
import aguascalientes_o0_reg from '../../../../../assets/plates/mexico/aguascalientes/reg2017.png';
import aguascalientes_o0_blank from '../../../../../assets/plates/mexico/aguascalientes/blank2017.png';
import aguascalientes_o0_blur from '../../../../../assets/plates/mexico/aguascalientes/blur2017.png';
import aguascalientes_o1_reg from '../../../../../assets/plates/mexico/aguascalientes/reg2012.png';
import aguascalientes_o1_blank from '../../../../../assets/plates/mexico/aguascalientes/blank2012.png';
import aguascalientes_o1_blur from '../../../../../assets/plates/mexico/aguascalientes/blur2012.png';
import aguascalientes_o2_reg from '../../../../../assets/plates/mexico/aguascalientes/reg2005.png';
import aguascalientes_o2_blank from '../../../../../assets/plates/mexico/aguascalientes/blank2005.png';
import aguascalientes_o2_blur from '../../../../../assets/plates/mexico/aguascalientes/blur2005.png';
import baja_california_reg from '../../../../../assets/plates/mexico/baja_california/reg2022.png';
import baja_california_blank from '../../../../../assets/plates/mexico/baja_california/blank2022.png';
import baja_california_blur from '../../../../../assets/plates/mexico/baja_california/blur2022.png';
import baja_california_o0_reg from '../../../../../assets/plates/mexico/baja_california/reg2020.png';
import baja_california_o0_blank from '../../../../../assets/plates/mexico/baja_california/blank2020.png';
import baja_california_o0_blur from '../../../../../assets/plates/mexico/baja_california/blur2020.png';
import baja_california_o1_reg from '../../../../../assets/plates/mexico/baja_california/reg2017.png';
import baja_california_o1_blank from '../../../../../assets/plates/mexico/baja_california/blank2017.png';
import baja_california_o1_blur from '../../../../../assets/plates/mexico/baja_california/blur2017.png';
import baja_california_o2_reg from '../../../../../assets/plates/mexico/baja_california/reg2014.png';
import baja_california_o2_blank from '../../../../../assets/plates/mexico/baja_california/blank2014.png';
import baja_california_o2_blur from '../../../../../assets/plates/mexico/baja_california/blur2014.png';
import baja_california_o3_reg from '../../../../../assets/plates/mexico/baja_california/reg2012.png';
import baja_california_o3_blank from '../../../../../assets/plates/mexico/baja_california/blank2012.png';
import baja_california_o3_blur from '../../../../../assets/plates/mexico/baja_california/blur2012.png';
import baja_california_o4_reg from '../../../../../assets/plates/mexico/baja_california/reg2010.png';
import baja_california_o4_blank from '../../../../../assets/plates/mexico/baja_california/blank2010.png';
import baja_california_o4_blur from '../../../../../assets/plates/mexico/baja_california/blur2010.png';
import baja_california_sur_reg from '../../../../../assets/plates/mexico/baja_california_sur/reg2022.png';
import baja_california_sur_blank from '../../../../../assets/plates/mexico/baja_california_sur/blank2022.png';
import baja_california_sur_blur from '../../../../../assets/plates/mexico/baja_california_sur/blur2022.png';
import baja_california_sur_o0_reg from '../../../../../assets/plates/mexico/baja_california_sur/reg2017.png';
import baja_california_sur_o0_blank from '../../../../../assets/plates/mexico/baja_california_sur/blank2017.png';
import baja_california_sur_o0_blur from '../../../../../assets/plates/mexico/baja_california_sur/blur2017.png';
import baja_california_sur_o1_reg from '../../../../../assets/plates/mexico/baja_california_sur/reg2006.png';
import baja_california_sur_o1_blank from '../../../../../assets/plates/mexico/baja_california_sur/blank2006.png';
import baja_california_sur_o1_blur from '../../../../../assets/plates/mexico/baja_california_sur/blur2006.png';
import campeche_reg from '../../../../../assets/plates/mexico/campeche/reg2023.png';
import campeche_blank from '../../../../../assets/plates/mexico/campeche/blank2023.png';
import campeche_blur from '../../../../../assets/plates/mexico/campeche/blur2023.png';
import campeche_o0_reg from '../../../../../assets/plates/mexico/campeche/reg2020.png';
import campeche_o0_blank from '../../../../../assets/plates/mexico/campeche/blank2020.png';
import campeche_o0_blur from '../../../../../assets/plates/mexico/campeche/blur2020.png';
import campeche_o1_reg from '../../../../../assets/plates/mexico/campeche/reg2017.png';
import campeche_o1_blank from '../../../../../assets/plates/mexico/campeche/blank2017.png';
import campeche_o1_blur from '../../../../../assets/plates/mexico/campeche/blur2017.png';
import campeche_o2_reg from '../../../../../assets/plates/mexico/campeche/reg2014.png';
import campeche_o2_blank from '../../../../../assets/plates/mexico/campeche/blank2014.png';
import campeche_o2_blur from '../../../../../assets/plates/mexico/campeche/blur2014.png';
import campeche_o3_reg from '../../../../../assets/plates/mexico/campeche/reg2011.png';
import campeche_o3_blank from '../../../../../assets/plates/mexico/campeche/blank2011.png';
import campeche_o3_blur from '../../../../../assets/plates/mexico/campeche/blur2011.png';
import campeche_o4_reg from '../../../../../assets/plates/mexico/campeche/reg2008.png';
import campeche_o4_blank from '../../../../../assets/plates/mexico/campeche/blank2008.png';
import campeche_o4_blur from '../../../../../assets/plates/mexico/campeche/blur2008.png';
import chihuahua_reg from '../../../../../assets/plates/mexico/chihuahua/reg2023.png';
import chihuahua_blank from '../../../../../assets/plates/mexico/chihuahua/blank2023.png';
import chihuahua_blur from '../../../../../assets/plates/mexico/chihuahua/blur2023.png';
import chihuahua_o0_reg from '../../../../../assets/plates/mexico/chihuahua/reg2022.png';
import chihuahua_o0_blank from '../../../../../assets/plates/mexico/chihuahua/blank2022.png';
import chihuahua_o0_blur from '../../../../../assets/plates/mexico/chihuahua/blur2022.png';
import chihuahua_o1_reg from '../../../../../assets/plates/mexico/chihuahua/reg2017.png';
import chihuahua_o1_blank from '../../../../../assets/plates/mexico/chihuahua/blank2017.png';
import chihuahua_o1_blur from '../../../../../assets/plates/mexico/chihuahua/blur2017.png';
import chihuahua_o2_reg from '../../../../../assets/plates/mexico/chihuahua/reg2016.png';
import chihuahua_o2_blank from '../../../../../assets/plates/mexico/chihuahua/blank2016.png';
import chihuahua_o2_blur from '../../../../../assets/plates/mexico/chihuahua/blur2016.png';
import chihuahua_o3_reg from '../../../../../assets/plates/mexico/chihuahua/reg2015.png';
import chihuahua_o3_blank from '../../../../../assets/plates/mexico/chihuahua/blank2015.png';
import chihuahua_o3_blur from '../../../../../assets/plates/mexico/chihuahua/blur2015.png';
import chihuahua_o4_reg from '../../../../../assets/plates/mexico/chihuahua/reg2012.png';
import chihuahua_o4_blank from '../../../../../assets/plates/mexico/chihuahua/blank2012.png';
import chihuahua_o4_blur from '../../../../../assets/plates/mexico/chihuahua/blur2012.png';
import chihuahua_o5_reg from '../../../../../assets/plates/mexico/chihuahua/reg2009.png';
import chihuahua_o5_blank from '../../../../../assets/plates/mexico/chihuahua/blank2009.png';
import chihuahua_o5_blur from '../../../../../assets/plates/mexico/chihuahua/blur2009.png';
import ciudad_de_mexico_reg from '../../../../../assets/plates/mexico/ciudad_de_mexico/reg2019.png';
import ciudad_de_mexico_blank from '../../../../../assets/plates/mexico/ciudad_de_mexico/blank2019.png';
import ciudad_de_mexico_blur from '../../../../../assets/plates/mexico/ciudad_de_mexico/blur2019.png';
import ciudad_de_mexico_o0_reg from '../../../../../assets/plates/mexico/ciudad_de_mexico/reg2016.png';
import ciudad_de_mexico_o0_blank from '../../../../../assets/plates/mexico/ciudad_de_mexico/blank2016.png';
import ciudad_de_mexico_o0_blur from '../../../../../assets/plates/mexico/ciudad_de_mexico/blur2016.png';
import coahuila_reg from '../../../../../assets/plates/mexico/coahuila/reg2022.png';
import coahuila_blank from '../../../../../assets/plates/mexico/coahuila/blank2022.png';
import coahuila_blur from '../../../../../assets/plates/mexico/coahuila/blur2022.png';
import coahuila_o0_reg from '../../../../../assets/plates/mexico/coahuila/reg2019.png';
import coahuila_o0_blank from '../../../../../assets/plates/mexico/coahuila/blank2019.png';
import coahuila_o0_blur from '../../../../../assets/plates/mexico/coahuila/blur2019.png';
import coahuila_o1_reg from '../../../../../assets/plates/mexico/coahuila/reg2017.png';
import coahuila_o1_blank from '../../../../../assets/plates/mexico/coahuila/blank2017.png';
import coahuila_o1_blur from '../../../../../assets/plates/mexico/coahuila/blur2017.png';
import coahuila_o2_reg from '../../../../../assets/plates/mexico/coahuila/reg2016.png';
import coahuila_o2_blank from '../../../../../assets/plates/mexico/coahuila/blank2016.png';
import coahuila_o2_blur from '../../../../../assets/plates/mexico/coahuila/blur2016.png';
import coahuila_o3_reg from '../../../../../assets/plates/mexico/coahuila/reg2013.png';
import coahuila_o3_blank from '../../../../../assets/plates/mexico/coahuila/blank2013.png';
import coahuila_o3_blur from '../../../../../assets/plates/mexico/coahuila/blur2013.png';
import coahuila_o4_reg from '../../../../../assets/plates/mexico/coahuila/reg2010.png';
import coahuila_o4_blank from '../../../../../assets/plates/mexico/coahuila/blank2010.png';
import coahuila_o4_blur from '../../../../../assets/plates/mexico/coahuila/blur2010.png';
import colima_reg from '../../../../../assets/plates/mexico/colima/reg2022.png';
import colima_blank from '../../../../../assets/plates/mexico/colima/blank2022.png';
import colima_blur from '../../../../../assets/plates/mexico/colima/blur2022.png';
import colima_o0_reg from '../../../../../assets/plates/mexico/colima/reg2017.png';
import colima_o0_blank from '../../../../../assets/plates/mexico/colima/blank2017.png';
import colima_o0_blur from '../../../../../assets/plates/mexico/colima/blur2017.png';
import colima_o1_reg from '../../../../../assets/plates/mexico/colima/reg2010.png';
import colima_o1_blank from '../../../../../assets/plates/mexico/colima/blank2010.png';
import colima_o1_blur from '../../../../../assets/plates/mexico/colima/blur2010.png';
import distrito_federal_reg from '../../../../../assets/plates/mexico/distrito_federal/reg2013.png';
import distrito_federal_blank from '../../../../../assets/plates/mexico/distrito_federal/blank2013.png';
import distrito_federal_blur from '../../../../../assets/plates/mexico/distrito_federal/blur2013.png';
import distrito_federal_o0_reg from '../../../../../assets/plates/mexico/distrito_federal/reg2008.png';
import distrito_federal_o0_blank from '../../../../../assets/plates/mexico/distrito_federal/blank2008.png';
import distrito_federal_o0_blur from '../../../../../assets/plates/mexico/distrito_federal/blur2008.png';
import durango_reg from '../../../../../assets/plates/mexico/durango/reg2023.png';
import durango_blank from '../../../../../assets/plates/mexico/durango/blank2023.png';
import durango_blur from '../../../../../assets/plates/mexico/durango/blur2023.png';
import durango_o0_reg from '../../../../../assets/plates/mexico/durango/reg2017.png';
import durango_o0_blank from '../../../../../assets/plates/mexico/durango/blank2017.png';
import durango_o0_blur from '../../../../../assets/plates/mexico/durango/blur2017.png';
import durango_o1_reg from '../../../../../assets/plates/mexico/durango/reg2009.png';
import durango_o1_blank from '../../../../../assets/plates/mexico/durango/blank2009.png';
import durango_o1_blur from '../../../../../assets/plates/mexico/durango/blur2009.png';
import estado_de_mexico_reg from '../../../../../assets/plates/mexico/estado_de_mexico/reg2024.png';
import estado_de_mexico_blank from '../../../../../assets/plates/mexico/estado_de_mexico/blank2024.png';
import estado_de_mexico_blur from '../../../../../assets/plates/mexico/estado_de_mexico/blur2024.png';
import estado_de_mexico_o0_reg from '../../../../../assets/plates/mexico/estado_de_mexico/reg2018.png';
import estado_de_mexico_o0_blank from '../../../../../assets/plates/mexico/estado_de_mexico/blank2018.png';
import estado_de_mexico_o0_blur from '../../../../../assets/plates/mexico/estado_de_mexico/blur2018.png';
import estado_de_mexico_o1_reg from '../../../../../assets/plates/mexico/estado_de_mexico/reg2016.png';
import estado_de_mexico_o1_blank from '../../../../../assets/plates/mexico/estado_de_mexico/blank2016.png';
import estado_de_mexico_o1_blur from '../../../../../assets/plates/mexico/estado_de_mexico/blur2016.png';
import estado_de_mexico_o2_reg from '../../../../../assets/plates/mexico/estado_de_mexico/reg2015.png';
import estado_de_mexico_o2_blank from '../../../../../assets/plates/mexico/estado_de_mexico/blank2015.png';
import estado_de_mexico_o2_blur from '../../../../../assets/plates/mexico/estado_de_mexico/blur2015.png';
import estado_de_mexico_o3_reg from '../../../../../assets/plates/mexico/estado_de_mexico/reg2009.png';
import estado_de_mexico_o3_blank from '../../../../../assets/plates/mexico/estado_de_mexico/blank2009.png';
import estado_de_mexico_o3_blur from '../../../../../assets/plates/mexico/estado_de_mexico/blur2009.png';
import guanajuato_reg from '../../../../../assets/plates/mexico/guanajuato/reg2020.png';
import guanajuato_blank from '../../../../../assets/plates/mexico/guanajuato/blank2020.png';
import guanajuato_blur from '../../../../../assets/plates/mexico/guanajuato/blur2020.png';
import guanajuato_o0_reg from '../../../../../assets/plates/mexico/guanajuato/reg2017.png';
import guanajuato_o0_blank from '../../../../../assets/plates/mexico/guanajuato/blank2017.png';
import guanajuato_o0_blur from '../../../../../assets/plates/mexico/guanajuato/blur2017.png';
import guanajuato_o1_reg from '../../../../../assets/plates/mexico/guanajuato/reg2016.png';
import guanajuato_o1_blank from '../../../../../assets/plates/mexico/guanajuato/blank2016.png';
import guanajuato_o1_blur from '../../../../../assets/plates/mexico/guanajuato/blur2016.png';
import guanajuato_o2_reg from '../../../../../assets/plates/mexico/guanajuato/reg2008.png';
import guanajuato_o2_blank from '../../../../../assets/plates/mexico/guanajuato/blank2008.png';
import guanajuato_o2_blur from '../../../../../assets/plates/mexico/guanajuato/blur2008.png';
import guerrero_reg from '../../../../../assets/plates/mexico/guerrero/reg2022.png';
import guerrero_blank from '../../../../../assets/plates/mexico/guerrero/blank2022.png';
import guerrero_blur from '../../../../../assets/plates/mexico/guerrero/blur2022.png';
import guerrero_o0_reg from '../../../../../assets/plates/mexico/guerrero/reg2018.png';
import guerrero_o0_blank from '../../../../../assets/plates/mexico/guerrero/blank2018.png';
import guerrero_o0_blur from '../../../../../assets/plates/mexico/guerrero/blur2018.png';
import guerrero_o1_reg from '../../../../../assets/plates/mexico/guerrero/reg2016.png';
import guerrero_o1_blank from '../../../../../assets/plates/mexico/guerrero/blank2016.png';
import guerrero_o1_blur from '../../../../../assets/plates/mexico/guerrero/blur2016.png';
import guerrero_o2_reg from '../../../../../assets/plates/mexico/guerrero/reg2015.png';
import guerrero_o2_blank from '../../../../../assets/plates/mexico/guerrero/blank2015.png';
import guerrero_o2_blur from '../../../../../assets/plates/mexico/guerrero/blur2015.png';
import guerrero_o3_reg from '../../../../../assets/plates/mexico/guerrero/reg2012.png';
import guerrero_o3_blank from '../../../../../assets/plates/mexico/guerrero/blank2012.png';
import guerrero_o3_blur from '../../../../../assets/plates/mexico/guerrero/blur2012.png';
import guerrero_o4_reg from '../../../../../assets/plates/mexico/guerrero/reg2009.png';
import guerrero_o4_blank from '../../../../../assets/plates/mexico/guerrero/blank2009.png';
import guerrero_o4_blur from '../../../../../assets/plates/mexico/guerrero/blur2009.png';
import hidalgo_reg from '../../../../../assets/plates/mexico/hidalgo/reg2023.png';
import hidalgo_blank from '../../../../../assets/plates/mexico/hidalgo/blank2023.png';
import hidalgo_blur from '../../../../../assets/plates/mexico/hidalgo/blur2023.png';
import hidalgo_o0_reg from '../../../../../assets/plates/mexico/hidalgo/reg2018.png';
import hidalgo_o0_blank from '../../../../../assets/plates/mexico/hidalgo/blank2018.png';
import hidalgo_o0_blur from '../../../../../assets/plates/mexico/hidalgo/blur2018.png';
import hidalgo_o1_reg from '../../../../../assets/plates/mexico/hidalgo/reg2013.png';
import hidalgo_o1_blank from '../../../../../assets/plates/mexico/hidalgo/blank2013.png';
import hidalgo_o1_blur from '../../../../../assets/plates/mexico/hidalgo/blur2013.png';
import hidalgo_o2_reg from '../../../../../assets/plates/mexico/hidalgo/reg2006.png';
import hidalgo_o2_blank from '../../../../../assets/plates/mexico/hidalgo/blank2006.png';
import hidalgo_o2_blur from '../../../../../assets/plates/mexico/hidalgo/blur2006.png';
import hidalgo_o3_reg from '../../../../../assets/plates/mexico/hidalgo/reg2002.png';
import hidalgo_o3_blank from '../../../../../assets/plates/mexico/hidalgo/blank2002.png';
import hidalgo_o3_blur from '../../../../../assets/plates/mexico/hidalgo/blur2002.png';
import jalisco_reg from '../../../../../assets/plates/mexico/jalisco/reg2019.png';
import jalisco_blank from '../../../../../assets/plates/mexico/jalisco/blank2019.png';
import jalisco_blur from '../../../../../assets/plates/mexico/jalisco/blur2019.png';
import jalisco_o0_reg from '../../../../../assets/plates/mexico/jalisco/reg2017.png';
import jalisco_o0_blank from '../../../../../assets/plates/mexico/jalisco/blank2017.png';
import jalisco_o0_blur from '../../../../../assets/plates/mexico/jalisco/blur2017.png';
import jalisco_o1_reg from '../../../../../assets/plates/mexico/jalisco/reg2011.png';
import jalisco_o1_blank from '../../../../../assets/plates/mexico/jalisco/blank2011.png';
import jalisco_o1_blur from '../../../../../assets/plates/mexico/jalisco/blur2011.png';
import jalisco_o2_reg from '../../../../../assets/plates/mexico/jalisco/reg2002.png';
import jalisco_o2_blank from '../../../../../assets/plates/mexico/jalisco/blank2002.png';
import jalisco_o2_blur from '../../../../../assets/plates/mexico/jalisco/blur2002.png';
import michoacan_reg from '../../../../../assets/plates/mexico/michoacan/reg2022.png';
import michoacan_blank from '../../../../../assets/plates/mexico/michoacan/blank2022.png';
import michoacan_blur from '../../../../../assets/plates/mexico/michoacan/blur2022.png';
import michoacan_o0_reg from '../../../../../assets/plates/mexico/michoacan/reg2019.png';
import michoacan_o0_blank from '../../../../../assets/plates/mexico/michoacan/blank2019.png';
import michoacan_o0_blur from '../../../../../assets/plates/mexico/michoacan/blur2019.png';
import michoacan_o1_reg from '../../../../../assets/plates/mexico/michoacan/reg2016.png';
import michoacan_o1_blank from '../../../../../assets/plates/mexico/michoacan/blank2016.png';
import michoacan_o1_blur from '../../../../../assets/plates/mexico/michoacan/blur2016.png';
import michoacan_o2_reg from '../../../../../assets/plates/mexico/michoacan/reg2012.png';
import michoacan_o2_blank from '../../../../../assets/plates/mexico/michoacan/blank2012.png';
import michoacan_o2_blur from '../../../../../assets/plates/mexico/michoacan/blur2012.png';
import michoacan_o3_reg from '../../../../../assets/plates/mexico/michoacan/reg2007.png';
import michoacan_o3_blank from '../../../../../assets/plates/mexico/michoacan/blank2007.png';
import michoacan_o3_blur from '../../../../../assets/plates/mexico/michoacan/blur2007.png';
import morelos_reg from '../../../../../assets/plates/mexico/morelos/reg2023.png';
import morelos_blank from '../../../../../assets/plates/mexico/morelos/blank2023.png';
import morelos_blur from '../../../../../assets/plates/mexico/morelos/blur2023.png';
import morelos_o0_reg from '../../../../../assets/plates/mexico/morelos/reg2019.png';
import morelos_o0_blank from '../../../../../assets/plates/mexico/morelos/blank2019.png';
import morelos_o0_blur from '../../../../../assets/plates/mexico/morelos/blur2019.png';
import morelos_o1_reg from '../../../../../assets/plates/mexico/morelos/reg2013.png';
import morelos_o1_blank from '../../../../../assets/plates/mexico/morelos/blank2013.png';
import morelos_o1_blur from '../../../../../assets/plates/mexico/morelos/blur2013.png';
import morelos_o2_reg from '../../../../../assets/plates/mexico/morelos/reg2008.png';
import morelos_o2_blank from '../../../../../assets/plates/mexico/morelos/blank2008.png';
import morelos_o2_blur from '../../../../../assets/plates/mexico/morelos/blur2008.png';
import nayarit_reg from '../../../../../assets/plates/mexico/nayarit/reg2022.png';
import nayarit_blank from '../../../../../assets/plates/mexico/nayarit/blank2022.png';
import nayarit_blur from '../../../../../assets/plates/mexico/nayarit/blur2022.png';
import nayarit_o0_reg from '../../../../../assets/plates/mexico/nayarit/reg2021.png';
import nayarit_o0_blank from '../../../../../assets/plates/mexico/nayarit/blank2021.png';
import nayarit_o0_blur from '../../../../../assets/plates/mexico/nayarit/blur2021.png';
import nayarit_o1_reg from '../../../../../assets/plates/mexico/nayarit/reg2017.png';
import nayarit_o1_blank from '../../../../../assets/plates/mexico/nayarit/blank2017.png';
import nayarit_o1_blur from '../../../../../assets/plates/mexico/nayarit/blur2017.png';
import nayarit_o2_reg from '../../../../../assets/plates/mexico/nayarit/reg2016.png';
import nayarit_o2_blank from '../../../../../assets/plates/mexico/nayarit/blank2016.png';
import nayarit_o2_blur from '../../../../../assets/plates/mexico/nayarit/blur2016.png';
import nayarit_o3_reg from '../../../../../assets/plates/mexico/nayarit/reg2013.png';
import nayarit_o3_blank from '../../../../../assets/plates/mexico/nayarit/blank2013.png';
import nayarit_o3_blur from '../../../../../assets/plates/mexico/nayarit/blur2013.png';
import nayarit_o4_reg from '../../../../../assets/plates/mexico/nayarit/reg2010.png';
import nayarit_o4_blank from '../../../../../assets/plates/mexico/nayarit/blank2010.png';
import nayarit_o4_blur from '../../../../../assets/plates/mexico/nayarit/blur2010.png';
import nuevo_leon_reg from '../../../../../assets/plates/mexico/nuevo_leon/reg2022.png';
import nuevo_leon_blank from '../../../../../assets/plates/mexico/nuevo_leon/blank2022.png';
import nuevo_leon_blur from '../../../../../assets/plates/mexico/nuevo_leon/blur2022.png';
import nuevo_leon_o0_reg from '../../../../../assets/plates/mexico/nuevo_leon/reg2016.png';
import nuevo_leon_o0_blank from '../../../../../assets/plates/mexico/nuevo_leon/blank2016.png';
import nuevo_leon_o0_blur from '../../../../../assets/plates/mexico/nuevo_leon/blur2016.png';
import nuevo_leon_o1_reg from '../../../../../assets/plates/mexico/nuevo_leon/reg2011.png';
import nuevo_leon_o1_blank from '../../../../../assets/plates/mexico/nuevo_leon/blank2011.png';
import nuevo_leon_o1_blur from '../../../../../assets/plates/mexico/nuevo_leon/blur2011.png';
import nuevo_leon_o2_reg from '../../../../../assets/plates/mexico/nuevo_leon/reg2008.png';
import nuevo_leon_o2_blank from '../../../../../assets/plates/mexico/nuevo_leon/blank2008.png';
import nuevo_leon_o2_blur from '../../../../../assets/plates/mexico/nuevo_leon/blur2008.png';
import oaxaca_reg from '../../../../../assets/plates/mexico/oaxaca/reg2023.png';
import oaxaca_blank from '../../../../../assets/plates/mexico/oaxaca/blank2023.png';
import oaxaca_blur from '../../../../../assets/plates/mexico/oaxaca/blur2023.png';
import oaxaca_o0_reg from '../../../../../assets/plates/mexico/oaxaca/reg2018.png';
import oaxaca_o0_blank from '../../../../../assets/plates/mexico/oaxaca/blank2018.png';
import oaxaca_o0_blur from '../../../../../assets/plates/mexico/oaxaca/blur2018.png';
import oaxaca_o1_reg from '../../../../../assets/plates/mexico/oaxaca/reg2013.png';
import oaxaca_o1_blank from '../../../../../assets/plates/mexico/oaxaca/blank2013.png';
import oaxaca_o1_blur from '../../../../../assets/plates/mexico/oaxaca/blur2013.png';
import oaxaca_o2_reg from '../../../../../assets/plates/mexico/oaxaca/reg2009.png';
import oaxaca_o2_blank from '../../../../../assets/plates/mexico/oaxaca/blank2009.png';
import oaxaca_o2_blur from '../../../../../assets/plates/mexico/oaxaca/blur2009.png';
import puebla_reg from '../../../../../assets/plates/mexico/puebla/reg2020.png';
import puebla_blank from '../../../../../assets/plates/mexico/puebla/blank2020.png';
import puebla_blur from '../../../../../assets/plates/mexico/puebla/blur2020.png';
import puebla_o0_reg from '../../../../../assets/plates/mexico/puebla/reg2019.png';
import puebla_o0_blank from '../../../../../assets/plates/mexico/puebla/blank2019.png';
import puebla_o0_blur from '../../../../../assets/plates/mexico/puebla/blur2019.png';
import puebla_o1_reg from '../../../../../assets/plates/mexico/puebla/reg2011.png';
import puebla_o1_blank from '../../../../../assets/plates/mexico/puebla/blank2011.png';
import puebla_o1_blur from '../../../../../assets/plates/mexico/puebla/blur2011.png';
import puebla_o2_reg from '../../../../../assets/plates/mexico/puebla/reg2010.png';
import puebla_o2_blank from '../../../../../assets/plates/mexico/puebla/blank2010.png';
import puebla_o2_blur from '../../../../../assets/plates/mexico/puebla/blur2010.png';
import queretaro_reg from '../../../../../assets/plates/mexico/queretaro/reg2022.png';
import queretaro_blank from '../../../../../assets/plates/mexico/queretaro/blank2022.png';
import queretaro_blur from '../../../../../assets/plates/mexico/queretaro/blur2022.png';
import queretaro_o0_reg from '../../../../../assets/plates/mexico/queretaro/reg2017.png';
import queretaro_o0_blank from '../../../../../assets/plates/mexico/queretaro/blank2017.png';
import queretaro_o0_blur from '../../../../../assets/plates/mexico/queretaro/blur2017.png';
import queretaro_o1_reg from '../../../../../assets/plates/mexico/queretaro/reg2008.png';
import queretaro_o1_blank from '../../../../../assets/plates/mexico/queretaro/blank2008.png';
import queretaro_o1_blur from '../../../../../assets/plates/mexico/queretaro/blur2008.png';
import quintana_roo_reg from '../../../../../assets/plates/mexico/quintana_roo/reg2023.png';
import quintana_roo_blank from '../../../../../assets/plates/mexico/quintana_roo/blank2023.png';
import quintana_roo_blur from '../../../../../assets/plates/mexico/quintana_roo/blur2023.png';
import quintana_roo_o0_reg from '../../../../../assets/plates/mexico/quintana_roo/reg2020.png';
import quintana_roo_o0_blank from '../../../../../assets/plates/mexico/quintana_roo/blank2020.png';
import quintana_roo_o0_blur from '../../../../../assets/plates/mexico/quintana_roo/blur2020.png';
import quintana_roo_o1_reg from '../../../../../assets/plates/mexico/quintana_roo/reg2017.png';
import quintana_roo_o1_blank from '../../../../../assets/plates/mexico/quintana_roo/blank2017.png';
import quintana_roo_o1_blur from '../../../../../assets/plates/mexico/quintana_roo/blur2017.png';
import quintana_roo_o2_reg from '../../../../../assets/plates/mexico/quintana_roo/reg2014.png';
import quintana_roo_o2_blank from '../../../../../assets/plates/mexico/quintana_roo/blank2014.png';
import quintana_roo_o2_blur from '../../../../../assets/plates/mexico/quintana_roo/blur2014.png';
import quintana_roo_o3_reg from '../../../../../assets/plates/mexico/quintana_roo/reg2011.png';
import quintana_roo_o3_blank from '../../../../../assets/plates/mexico/quintana_roo/blank2011.png';
import quintana_roo_o3_blur from '../../../../../assets/plates/mexico/quintana_roo/blur2011.png';
import quintana_roo_o4_reg from '../../../../../assets/plates/mexico/quintana_roo/reg2007.png';
import quintana_roo_o4_blank from '../../../../../assets/plates/mexico/quintana_roo/blank2007.png';
import quintana_roo_o4_blur from '../../../../../assets/plates/mexico/quintana_roo/blur2007.png';
import san_luis_potosi_reg from '../../../../../assets/plates/mexico/san_luis_potosi/reg2022.png';
import san_luis_potosi_blank from '../../../../../assets/plates/mexico/san_luis_potosi/blank2022.png';
import san_luis_potosi_blur from '../../../../../assets/plates/mexico/san_luis_potosi/blur2022.png';
import san_luis_potosi_o0_reg from '../../../../../assets/plates/mexico/san_luis_potosi/reg2016.png';
import san_luis_potosi_o0_blank from '../../../../../assets/plates/mexico/san_luis_potosi/blank2016.png';
import san_luis_potosi_o0_blur from '../../../../../assets/plates/mexico/san_luis_potosi/blur2016.png';
import san_luis_potosi_o1_reg from '../../../../../assets/plates/mexico/san_luis_potosi/reg2013.png';
import san_luis_potosi_o1_blank from '../../../../../assets/plates/mexico/san_luis_potosi/blank2013.png';
import san_luis_potosi_o1_blur from '../../../../../assets/plates/mexico/san_luis_potosi/blur2013.png';
import san_luis_potosi_o2_reg from '../../../../../assets/plates/mexico/san_luis_potosi/reg2010.png';
import san_luis_potosi_o2_blank from '../../../../../assets/plates/mexico/san_luis_potosi/blank2010.png';
import san_luis_potosi_o2_blur from '../../../../../assets/plates/mexico/san_luis_potosi/blur2010.png';
import sinaloa_reg from '../../../../../assets/plates/mexico/sinaloa/reg2021.png';
import sinaloa_blank from '../../../../../assets/plates/mexico/sinaloa/blank2021.png';
import sinaloa_blur from '../../../../../assets/plates/mexico/sinaloa/blur2021.png';
import sinaloa_o0_reg from '../../../../../assets/plates/mexico/sinaloa/reg2017.png';
import sinaloa_o0_blank from '../../../../../assets/plates/mexico/sinaloa/blank2017.png';
import sinaloa_o0_blur from '../../../../../assets/plates/mexico/sinaloa/blur2017.png';
import sinaloa_o1_reg from '../../../../../assets/plates/mexico/sinaloa/reg2012.png';
import sinaloa_o1_blank from '../../../../../assets/plates/mexico/sinaloa/blank2012.png';
import sinaloa_o1_blur from '../../../../../assets/plates/mexico/sinaloa/blur2012.png';
import sinaloa_o2_reg from '../../../../../assets/plates/mexico/sinaloa/reg2006.png';
import sinaloa_o2_blank from '../../../../../assets/plates/mexico/sinaloa/blank2006.png';
import sinaloa_o2_blur from '../../../../../assets/plates/mexico/sinaloa/blur2006.png';
import sonora_reg from '../../../../../assets/plates/mexico/sonora/reg2014.png';
import sonora_blank from '../../../../../assets/plates/mexico/sonora/blank2014.png';
import sonora_blur from '../../../../../assets/plates/mexico/sonora/blur2014.png';
import sonora_o0_reg from '../../../../../assets/plates/mexico/sonora/reg2011.png';
import sonora_o0_blank from '../../../../../assets/plates/mexico/sonora/blank2011.png';
import sonora_o0_blur from '../../../../../assets/plates/mexico/sonora/blur2011.png';
import sonora_o1_reg from '../../../../../assets/plates/mexico/sonora/reg2008.png';
import sonora_o1_blank from '../../../../../assets/plates/mexico/sonora/blank2008.png';
import sonora_o1_blur from '../../../../../assets/plates/mexico/sonora/blur2008.png';
import tabasco_reg from '../../../../../assets/plates/mexico/tabasco/reg2020.png';
import tabasco_blank from '../../../../../assets/plates/mexico/tabasco/blank2020.png';
import tabasco_blur from '../../../../../assets/plates/mexico/tabasco/blur2020.png';
import tabasco_o0_reg from '../../../../../assets/plates/mexico/tabasco/reg2017.png';
import tabasco_o0_blank from '../../../../../assets/plates/mexico/tabasco/blank2017.png';
import tabasco_o0_blur from '../../../../../assets/plates/mexico/tabasco/blur2017.png';
import tabasco_o1_reg from '../../../../../assets/plates/mexico/tabasco/reg2014.png';
import tabasco_o1_blank from '../../../../../assets/plates/mexico/tabasco/blank2014.png';
import tabasco_o1_blur from '../../../../../assets/plates/mexico/tabasco/blur2014.png';
import tabasco_o2_reg from '../../../../../assets/plates/mexico/tabasco/reg2009.png';
import tabasco_o2_blank from '../../../../../assets/plates/mexico/tabasco/blank2009.png';
import tabasco_o2_blur from '../../../../../assets/plates/mexico/tabasco/blur2009.png';
import tamaulipas_reg from '../../../../../assets/plates/mexico/tamaulipas/reg2023.png';
import tamaulipas_blank from '../../../../../assets/plates/mexico/tamaulipas/blank2023.png';
import tamaulipas_blur from '../../../../../assets/plates/mexico/tamaulipas/blur2023.png';
import tamaulipas_o0_reg from '../../../../../assets/plates/mexico/tamaulipas/reg2022.png';
import tamaulipas_o0_blank from '../../../../../assets/plates/mexico/tamaulipas/blank2022.png';
import tamaulipas_o0_blur from '../../../../../assets/plates/mexico/tamaulipas/blur2022.png';
import tamaulipas_o1_reg from '../../../../../assets/plates/mexico/tamaulipas/reg2019.png';
import tamaulipas_o1_blank from '../../../../../assets/plates/mexico/tamaulipas/blank2019.png';
import tamaulipas_o1_blur from '../../../../../assets/plates/mexico/tamaulipas/blur2019.png';
import tamaulipas_o2_reg from '../../../../../assets/plates/mexico/tamaulipas/reg2016.png';
import tamaulipas_o2_blank from '../../../../../assets/plates/mexico/tamaulipas/blank2016.png';
import tamaulipas_o2_blur from '../../../../../assets/plates/mexico/tamaulipas/blur2016.png';
import tamaulipas_o3_reg from '../../../../../assets/plates/mexico/tamaulipas/reg2013.png';
import tamaulipas_o3_blank from '../../../../../assets/plates/mexico/tamaulipas/blank2013.png';
import tamaulipas_o3_blur from '../../../../../assets/plates/mexico/tamaulipas/blur2013.png';
import tamaulipas_o4_reg from '../../../../../assets/plates/mexico/tamaulipas/reg2010.png';
import tamaulipas_o4_blank from '../../../../../assets/plates/mexico/tamaulipas/blank2010.png';
import tamaulipas_o4_blur from '../../../../../assets/plates/mexico/tamaulipas/blur2010.png';
import tlaxcala_reg from '../../../../../assets/plates/mexico/tlaxcala/reg2023.png';
import tlaxcala_blank from '../../../../../assets/plates/mexico/tlaxcala/blank2023.png';
import tlaxcala_blur from '../../../../../assets/plates/mexico/tlaxcala/blur2023.png';
import tlaxcala_o0_reg from '../../../../../assets/plates/mexico/tlaxcala/reg2020.png';
import tlaxcala_o0_blank from '../../../../../assets/plates/mexico/tlaxcala/blank2020.png';
import tlaxcala_o0_blur from '../../../../../assets/plates/mexico/tlaxcala/blur2020.png';
import tlaxcala_o1_reg from '../../../../../assets/plates/mexico/tlaxcala/reg2017.png';
import tlaxcala_o1_blank from '../../../../../assets/plates/mexico/tlaxcala/blank2017.png';
import tlaxcala_o1_blur from '../../../../../assets/plates/mexico/tlaxcala/blur2017.png';
import tlaxcala_o2_reg from '../../../../../assets/plates/mexico/tlaxcala/reg2015.png';
import tlaxcala_o2_blank from '../../../../../assets/plates/mexico/tlaxcala/blank2015.png';
import tlaxcala_o2_blur from '../../../../../assets/plates/mexico/tlaxcala/blur2015.png';
import tlaxcala_o3_reg from '../../../../../assets/plates/mexico/tlaxcala/reg2012.png';
import tlaxcala_o3_blank from '../../../../../assets/plates/mexico/tlaxcala/blank2012.png';
import tlaxcala_o3_blur from '../../../../../assets/plates/mexico/tlaxcala/blur2012.png';
import tlaxcala_o4_reg from '../../../../../assets/plates/mexico/tlaxcala/reg2006.png';
import tlaxcala_o4_blank from '../../../../../assets/plates/mexico/tlaxcala/blank2006.png';
import tlaxcala_o4_blur from '../../../../../assets/plates/mexico/tlaxcala/blur2006.png';
import veracruz_reg from '../../../../../assets/plates/mexico/veracruz/reg2019.png';
import veracruz_blank from '../../../../../assets/plates/mexico/veracruz/blank2019.png';
import veracruz_blur from '../../../../../assets/plates/mexico/veracruz/blur2019.png';
import veracruz_o0_reg from '../../../../../assets/plates/mexico/veracruz/reg2017.png';
import veracruz_o0_blank from '../../../../../assets/plates/mexico/veracruz/blank2017.png';
import veracruz_o0_blur from '../../../../../assets/plates/mexico/veracruz/blur2017.png';
import veracruz_o1_reg from '../../../../../assets/plates/mexico/veracruz/reg2011.png';
import veracruz_o1_blank from '../../../../../assets/plates/mexico/veracruz/blank2011.png';
import veracruz_o1_blur from '../../../../../assets/plates/mexico/veracruz/blur2011.png';
import veracruz_o2_reg from '../../../../../assets/plates/mexico/veracruz/reg2008.png';
import veracruz_o2_blank from '../../../../../assets/plates/mexico/veracruz/blank2008.png';
import veracruz_o2_blur from '../../../../../assets/plates/mexico/veracruz/blur2008.png';
import yucatan_reg from '../../../../../assets/plates/mexico/yucatan/reg2020.png';
import yucatan_blank from '../../../../../assets/plates/mexico/yucatan/blank2020.png';
import yucatan_blur from '../../../../../assets/plates/mexico/yucatan/blur2020.png';
import yucatan_o0_reg from '../../../../../assets/plates/mexico/yucatan/reg2017.png';
import yucatan_o0_blank from '../../../../../assets/plates/mexico/yucatan/blank2017.png';
import yucatan_o0_blur from '../../../../../assets/plates/mexico/yucatan/blur2017.png';
import yucatan_o1_reg from '../../../../../assets/plates/mexico/yucatan/reg2013.png';
import yucatan_o1_blank from '../../../../../assets/plates/mexico/yucatan/blank2013.png';
import yucatan_o1_blur from '../../../../../assets/plates/mexico/yucatan/blur2013.png';
import yucatan_o2_reg from '../../../../../assets/plates/mexico/yucatan/reg2009.png';
import yucatan_o2_blank from '../../../../../assets/plates/mexico/yucatan/blank2009.png';
import yucatan_o2_blur from '../../../../../assets/plates/mexico/yucatan/blur2009.png';
import zacatecas_reg from '../../../../../assets/plates/mexico/zacatecas/reg2022.png';
import zacatecas_blank from '../../../../../assets/plates/mexico/zacatecas/blank2022.png';
import zacatecas_blur from '../../../../../assets/plates/mexico/zacatecas/blur2022.png';
import zacatecas_o0_reg from '../../../../../assets/plates/mexico/zacatecas/reg2017.png';
import zacatecas_o0_blank from '../../../../../assets/plates/mexico/zacatecas/blank2017.png';
import zacatecas_o0_blur from '../../../../../assets/plates/mexico/zacatecas/blur2017.png';
import zacatecas_o1_reg from '../../../../../assets/plates/mexico/zacatecas/reg2011.png';
import zacatecas_o1_blank from '../../../../../assets/plates/mexico/zacatecas/blank2011.png';
import zacatecas_o1_blur from '../../../../../assets/plates/mexico/zacatecas/blur2011.png';
import zacatecas_o2_reg from '../../../../../assets/plates/mexico/zacatecas/reg2008.png';
import zacatecas_o2_blank from '../../../../../assets/plates/mexico/zacatecas/blank2008.png';
import zacatecas_o2_blur from '../../../../../assets/plates/mexico/zacatecas/blur2008.png';


import { CANADA_PROVINCE_NAMES, MEXICO_STATE_NAMES, STATE_NAMES, TERRITORY_NAMES, US_STATE_NAMES } from '../constants';


export enum PLATE_TYPE {
    REGULAR,
    VANITY,
    OLD,
}

export enum PLATE_STATE {
    SHOW = 0,
    BLANK = 1,
    BLUR = 2,
}

export type RECT_COORDS = [number, number, number, number, number?, number?, number?, number?]; // 0_x, 0_y, width, height, 0_x2?, 0_y2?, 1_x?, 1_y?
export type PLATE_TUPLE = [string, string, string, RECT_COORDS, number, number?, [number, number]?, string?]; // reg, blank, blur, RECT_COORDS, startYear, endYear?, [width, height], special identifier?

export const PLATES = new Map<STATE_NAMES, Map<PLATE_TYPE, PLATE_TUPLE[]>>([
    [US_STATE_NAMES.MAINE, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[maine_reg, maine_blank, maine_blur, [82, 80, 14, 18], 1999]]] //
    ])],
    [US_STATE_NAMES.NEW_HAMPSHIRE, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[new_hampshire_reg, new_hampshire_blank, new_hampshire_blur, [82, 80, 14, 18], 1999]]] //
    ])],
    [US_STATE_NAMES.VERMONT, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[vermont_reg, vermont_blank, vermont_blur, [1000,1000, 14, 18], 1990]]] //
    ])],
    [US_STATE_NAMES.NEW_YORK, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[new_york_reg, new_york_blank, new_york_blur, [1000,1000, 14, 18], 2020]]], //
        [PLATE_TYPE.OLD, [
            [new_york_o0_reg, new_york_o0_blank, new_york_o0_blur, [1000,1000, 14, 18], 2010, 2020], //
            [new_york_o1_reg, new_york_o1_blank, new_york_o1_blur, [1000,1000, 14, 18], 2001, 2010] //
        ]]
    ])],
    [US_STATE_NAMES.PENNSYLVANIA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[pennsylvania_reg, pennsylvania_blank, pennsylvania_blur, [5, 5, 14, 18], 2004]]], //
        [PLATE_TYPE.OLD, [
            [pennsylvania_o0_reg, pennsylvania_o0_blank, pennsylvania_o0_blur, [5, 5, 14, 18], 1999, 2004] //
        ]]
    ])],
    [US_STATE_NAMES.OHIO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[ohio_reg, ohio_blank, ohio_blur, [82, 80, 14, 18], 2021]]],
        [PLATE_TYPE.OLD, [
            [ohio_o0_reg, ohio_o0_blank, ohio_o0_blur, [5, 80, 14, 18, 5, 80, 82, 80], 2013, 2021], //
            [ohio_o1_reg, ohio_o1_blank, ohio_o1_blur, [82, 5, 14, 18], 2009, 2013],
            [ohio_o2_reg, ohio_o2_blank, ohio_o2_blur, [5, 80, 14, 18, 5, 80, 82, 80], 2004, 2009], //
            [ohio_o3_reg, ohio_o3_blank, ohio_o3_blur, [82, 5, 14, 18], 2001, 2004],
            [ohio_o4_reg, ohio_o4_blank, ohio_o4_blur, [82, 5, 14, 18], 1997, 2001]
        ]],
        [PLATE_TYPE.VANITY, [
            [ohio_sp0_reg, ohio_sp0_blank, ohio_sp0_blur, [82, 5, 14, 18], 2023, undefined, undefined, "Ohio State Buckeyes"], //
        ]],
    ])],
    [US_STATE_NAMES.MICHIGAN, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[michigan_reg, michigan_blank, michigan_blur, [82, 5, 14, 18], 2013]]], //
        [PLATE_TYPE.OLD, [
            [michigan_o0_reg, michigan_o0_blank, michigan_o0_blur, [82, 5, 14, 18], 2007, 2013], //
            [michigan_o1_reg, michigan_o1_blank, michigan_o1_blur, [82, 80, 14, 18, 5, 80], 1983, 2007] //
        ]],
        [PLATE_TYPE.VANITY, [
            [michigan_sp0_reg, michigan_sp0_blank, michigan_sp0_blur, [82, 5, 14, 18], 1965, undefined, undefined, "Winter Wonderland"], //
            [michigan_sp1_reg, michigan_sp1_blank, michigan_sp1_blur, [82, 5, 14, 18], 2013, undefined, undefined, "Mackinac Bridge"], //
        ]]
    ])],
    [US_STATE_NAMES.INDIANA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [indiana_reg, indiana_blank, indiana_blur, [82, 5, 14, 18], 2017],
            [indiana2_reg, indiana2_blank, indiana2_blur, [82, 5, 14, 18], 2011],
        ]],
        [PLATE_TYPE.OLD, [
            [indiana_o0_reg, indiana_o0_blank, indiana_o0_blur, [82, 5, 14, 18], 2013, 2016],
            [indiana_o1_reg, indiana_o1_blank, indiana_o1_blur, [5, 5, 14, 18], 2008, 2013],
            [indiana_o2_reg, indiana_o2_blank, indiana_o2_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2007, 2011], //
        ]],
        [PLATE_TYPE.VANITY, [
            [indiana_sp0_reg, indiana_sp0_blank, indiana_sp0_blur, [82, 5, 14, 18], 1991, undefined, undefined, "Purdue"], //
            [indiana_sp1_reg, indiana_sp1_blank, indiana_sp1_blur, [82, 5, 14, 18], 2007, undefined, undefined, "Indiana University"], //
        ]],
    ])],
    [US_STATE_NAMES.ILLINOIS, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[illinois_reg, illinois_blank, illinois_blur, [82, 5, 14, 18], 2017]]],
        [PLATE_TYPE.OLD, [
            [illinois_o0_reg, illinois_o0_blank, illinois_o0_blur, [82, 5, 14, 18], 2001, 2017]
        ]]
    ])],
    [US_STATE_NAMES.WISCONSIN, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[wisconsin_reg, wisconsin_blank, wisconsin_blur, [82, 80, 14, 18, 5, 80, 14, 18], 2000]]]
    ])],
    [US_STATE_NAMES.MINNESOTA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[minnesota_reg, minnesota_blank, minnesota_blur, [82, 80, 14, 18], 1987]]],
        [PLATE_TYPE.VANITY, [
            [minnesota_sp0_reg, minnesota_sp0_blank, minnesota_sp0_blur, [82, 80, 14, 18], 2024, undefined, undefined, "Blackout"], //
        ]],
    ])],
    [US_STATE_NAMES.NORTH_DAKOTA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[north_dakota_reg, north_dakota_blank, north_dakota_blur, [82, 5, 14, 18], 2015]]], //
        [PLATE_TYPE.OLD, [
            [north_dakota_o0_reg, north_dakota_o0_blank, north_dakota_o0_blur, [82, 5, 14, 18], 1993, 2015], //
        ]]
    ])],
    [US_STATE_NAMES.MONTANA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [montana_reg, montana_blank, montana_blur, [82, 5, 14, 18], 2010],
            [montana2_reg, montana2_blank, montana2_blur, [82, 5, 14, 18], 2006],
            [montana3_reg, montana3_blank, montana3_blur, [82, 5, 14, 18], 2000],
            [montana4_reg, montana4_blank, montana4_blur, [82, 5, 14, 18], 1991],
            [montana5_reg, montana5_blank, montana5_blur, [82, 5, 14, 18], 1989],
        ]]
    ])],
    [US_STATE_NAMES.IDAHO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[idaho_reg, idaho_blank, idaho_blur, [82, 80, 14, 18], 1991]]]
    ])],
    [US_STATE_NAMES.WASHINGTON, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[washington_reg, washington_blank, washington_blur, [82, 5, 14, 18], 1987]]], //
        [PLATE_TYPE.VANITY, [
            [washington_sp0_reg, washington_sp0_blank, washington_sp0_blur, [82, 5, 14, 18], 2012, undefined, undefined, "Washington State University"], //
        ]],
    ])],
    [US_STATE_NAMES.OREGON, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[oregon_reg, oregon_blank, oregon_blur, [82, 80, 14, 18, 82, 80, 5, 80], 1989]]], //
        [PLATE_TYPE.VANITY, [
            [oregon_sp0_reg, oregon_sp0_blank, oregon_sp0_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2002, 2022, undefined, "Crater Lake"],
            [oregon_sp1_reg, oregon_sp1_blank, oregon_sp1_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2022, undefined, undefined, "Crater Lake"], //
        ]],
    ])],
    [US_STATE_NAMES.WYOMING, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [wyoming_reg, wyoming_blank, wyoming_blur, [5, 5, 14, 18], 2025], //
            [wyoming2_reg, wyoming2_blank, wyoming2_blur, [5, 5, 14, 18], 2016, 2024], //
        ]],
        [PLATE_TYPE.OLD, [
            [wyoming_o0_reg, wyoming_o0_blank, wyoming_o0_blur, [5, 5, 14, 18], 2008, 2016], //
        ]]
    ])],
    [US_STATE_NAMES.SOUTH_DAKOTA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[south_dakota_reg, south_dakota_blank, south_dakota_blur, [82, 80, 14, 18], 2016]]], //
        [PLATE_TYPE.OLD, [
            [south_dakota_o0_reg, south_dakota_o0_blank, south_dakota_o0_blur, [82, 80, 14, 18], 2006, 2016], //
        ]]
    ])],
    [US_STATE_NAMES.IOWA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [iowa_reg, iowa_blank, iowa_blur, [5, 80, 14, 18], 2018], //
        ]],
        [PLATE_TYPE.OLD, [
            [iowa_o0_reg, iowa_o0_blank, iowa_o0_blur, [5, 80, 14, 18], 1997, 2017], //
        ]],
        [PLATE_TYPE.VANITY, [
            [iowa_sp0_reg, iowa_sp0_blank, iowa_sp0_blur, [5, 80, 14, 18], 2019, undefined, undefined, "Blackout"], //
        ]]
    ])],
    [US_STATE_NAMES.MISSOURI, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [missouri_reg, missouri_blank, missouri_blur, [45, 30, 10, 38], 2018], //
        ]],
        [PLATE_TYPE.OLD, [
            [missouri_o0_reg, missouri_o0_blank, missouri_o0_blur, [45, 30, 10, 38], 2008, 2018], //
        ]]
    ])],
    [US_STATE_NAMES.KENTUCKY, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [kentucky_reg, kentucky_blank, kentucky_blur, [82, 80, 14, 18], 2020], //
            [kentucky2_reg, kentucky2_blank, kentucky2_blur, [82, 80, 14, 18], 2020], //
        ]],
        [PLATE_TYPE.OLD, [
            [kentucky_o0_reg, kentucky_o0_blank, kentucky_o0_blur, [82, 80, 14, 18], 2011, 2020], //
            [kentucky_o1_reg, kentucky_o1_blank, kentucky_o1_blur, [82, 80, 14, 18], 2005, 2011], //
        ]],
        [PLATE_TYPE.VANITY, [
            [kentucky_sp0_reg, kentucky_sp0_blank, kentucky_sp0_blur, [82, 80, 14, 18], 2023, undefined, undefined, "In God We Trust"], //
            [kentucky_sp1_reg, kentucky_sp1_blank, kentucky_sp1_blur, [82, 80, 14, 18], 2009, undefined, undefined, "Friends of Coal"], //
        ]],
    ])],
    [US_STATE_NAMES.WEST_VIRGINIA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [west_virginia_reg, west_virginia_blank, west_virginia_blur, [82, 80, 14, 18], 1996] //
        ]]
    ])],
    [US_STATE_NAMES.MARYLAND, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [maryland_reg, maryland_blank, maryland_blur, [82, 5, 14, 18], 2016] //
        ]],
        [PLATE_TYPE.OLD, [
            [maryland_o0_reg, maryland_o0_blank, maryland_o0_blur, [82, 5, 14, 18], 2012, 2016], //
            [maryland_o1_reg, maryland_o1_blank, maryland_o1_blur, [82, 5, 14, 18], 1987, 2012] //
        ]],
        [PLATE_TYPE.VANITY, [
            [maryland_sp0_reg, maryland_sp0_blank, maryland_sp0_blur, [82, 5, 14, 18], 2018, undefined, undefined, "Chesapeake Bay"], //
        ]]
    ])],
    [US_STATE_NAMES.DELAWARE, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [delaware_reg, delaware_blank, delaware_blur, [82, 80, 14, 18], 2008] //
        ]]
    ])],
    [US_STATE_NAMES.NEW_JERSEY, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [new_jersey_reg, new_jersey_blank, new_jersey_blur, [1000,1000, 14, 18], 1993] //
        ]],
        [PLATE_TYPE.VANITY, [
            [new_jersey_sp0_reg, new_jersey_sp0_blank, new_jersey_sp0_blur, [1000,1000, 14, 18], 2016, undefined, undefined, "Shore to Please"], //
        ]],
    ])],
    [US_STATE_NAMES.CONNECTICUT, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [connecticut_reg, connecticut_blank, connecticut_blur, [82, 5, 14, 18], 2000] //
        ]]
    ])],
    [US_STATE_NAMES.MASSACHUSETTS, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [massachusetts_reg, massachusetts_blank, massachusetts_blur, [82, 5, 14, 18], 1993] //
        ]],
        [PLATE_TYPE.VANITY, [
            [massachusetts_sp0_reg, massachusetts_sp0_blank, massachusetts_sp0_blur, [82, 5, 14, 18], 1996, undefined, undefined, "Cape Cod and Islands"], //
        ]],
    ])],
    [US_STATE_NAMES.RHODE_ISLAND, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [rhode_island_reg, rhode_island_blank, rhode_island_blur, [82, 80, 14, 18], 1997] //
        ]]
    ])],
    [US_STATE_NAMES.VIRGINIA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [virginia_reg_2008, virginia_blank_2008, virginia_blur_2008, [82, 5, 14, 10, 82, 5, 5, 5], 2008] //
        ]],
        [PLATE_TYPE.OLD, [
            [virginia_reg_2006, virginia_blank_2006, virginia_blur_2006, [82, 5, 14, 10, 82, 5, 5, 5], 2006, 2008] //
        ]],
        [PLATE_TYPE.VANITY, [
            [virginia_sp0_reg, virginia_sp0_blank, virginia_sp0_blur, [82, 5, 14, 10, 82, 5, 5, 5], 1992, undefined, undefined, "Scenic Virginia"], //
        ]]
    ])],
    
    [US_STATE_NAMES.TENNESSEE, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [tennessee_reg_2022, tennessee_blank_2022, tennessee_blur_2022, [1000,1000, 14, 18], 2022] //
        ]],
        [PLATE_TYPE.OLD, [
            [tennessee_reg_2006, tennessee_blank_2006, tennessee_blur_2006, [1000,1000, 14, 18], 2006, 2022] //
        ]],
        [PLATE_TYPE.VANITY, [
            [tennessee_sp0_reg, tennessee_sp0_blank, tennessee_sp0_blur, [1000,1000, 14, 18], 2017, undefined, undefined, "Don't Tread On Me"], //
        ]]
    ])],
    
    [US_STATE_NAMES.ARKANSAS, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [arkansas_reg_2006, arkansas_blank_2006, arkansas_blur_2006, [82, 5, 14, 18], 2006] //
        ]],
        [PLATE_TYPE.VANITY, [
            [arkansas_sp0_reg, arkansas_sp0_blank, arkansas_sp0_blur, [82, 5, 14, 18, 82, 5, 5, 5], 1994, undefined, undefined, "Razorbacks"], //
        ]],
    ])],
    
    [US_STATE_NAMES.OKLAHOMA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [oklahoma_reg_2024, oklahoma_blank_2024, oklahoma_blur_2024, [82, 5, 14, 10, 82, 5, 5, 5], 2024], //
            [oklahoma_reg_2017, oklahoma_blank_2017, oklahoma_blur_2017, [82, 5, 14, 10, 82, 5, 5, 5], 2017, 2024], //
        ]],
        [PLATE_TYPE.OLD, [
            [oklahoma_reg_1995, oklahoma_blank_1995, oklahoma_blur_1995, [82, 5, 14, 10, 82, 5, 5, 5], 1995, 2009], //
            [oklahoma_reg_2009, oklahoma_blank_2009, oklahoma_blur_2009, [82, 5, 14, 10, 82, 5, 5, 5], 2009, 2017], //
        ]],
        [PLATE_TYPE.VANITY, [
            [oklahoma_sp0_reg, oklahoma_sp0_blank, oklahoma_sp0_blur, [82, 5, 14, 10, 82, 5, 5, 5], 2008, undefined, undefined, "In God We Trust"], //
        ]]
    ])],
    
    [US_STATE_NAMES.KANSAS, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [kansas_reg_2024, kansas_blank_2024, kansas_blur_2024, [82, 5, 14, 18, 82, 5, 5, 5], 2024] //
        ]],
        [PLATE_TYPE.OLD, [
            [kansas_reg_2007, kansas_blank_2007, kansas_blur_2007, [82, 5, 14, 18], 2007, 2024], //
            [kansas_reg_2001, kansas_blank_2001, kansas_blur_2001, [1000,1000, 14, 18], 2001, 2007], //
        ]]
    ])],
    
    [US_STATE_NAMES.NEBRASKA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [nebraska_reg_2023, nebraska_blank_2023, nebraska_blur_2023, [82, 5, 14, 18], 2023] //
        ]],
        [PLATE_TYPE.OLD, [
            [nebraska_reg_2002, nebraska_blank_2002, nebraska_blur_2002, [82, 5, 14, 18], 2002, 2005], //
            [nebraska_reg_2005, nebraska_blank_2005, nebraska_blur_2005, [82, 5, 14, 18], 2005, 2011], //
            [nebraska_reg_2011, nebraska_blank_2011, nebraska_blur_2011, [82, 5, 14, 18], 2011, 2017], //
            [nebraska_reg_2017, nebraska_blank_2017, nebraska_blur_2017, [82, 5, 14, 18], 2017, 2023] //
        ]],
        [PLATE_TYPE.VANITY, [
            [nebraska_sp0_reg, nebraska_sp0_blank, nebraska_sp0_blur, [82, 5, 14, 18], 2016, undefined, undefined, "Mountain Lion Conservation"] //
        ]]
    ])],
    
    [US_STATE_NAMES.COLORADO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [colorado_reg_2000, colorado_blank_2000, colorado_blur_2000, [82, 80, 12, 16, 82, 80, 5, 80], 2000] //
        ]],
        [PLATE_TYPE.VANITY, [
            [colorado_sp0_reg, colorado_sp0_blank, colorado_sp0_blur, [82, 80, 12, 16, 82, 80, 5, 80], 2001, undefined, undefined, "Columbine"], //
            [colorado_sp1_reg, colorado_sp1_blank, colorado_sp1_blur, [82, 80, 12, 16, 82, 80, 5, 80], 2022, undefined, undefined, "Blackout"], //
            [colorado_sp2_reg, colorado_sp2_blank, colorado_sp2_blur, [82, 80, 12, 16, 82, 80, 5, 80], 2000, undefined, undefined, "Fleet"], //
        ]],
    ])],

    [US_STATE_NAMES.UTAH, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [utah_reg, utah_blank, utah_blur, [85, 5, 10, 18], 2008], //
            [utah2_reg, utah2_blank, utah2_blur, [85, 5, 10, 18], 2009], //
            [utah3_reg, utah3_blank, utah3_blur, [85, 5, 10, 18], 2017], //
        ]]
    ])],
    [US_STATE_NAMES.NEVADA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [nevada_reg, nevada_blank, nevada_blur, [82, 5, 14, 18], 2017] //
        ]],
        [PLATE_TYPE.OLD, [
            [nevada_o0_reg, nevada_o0_blank, nevada_o0_blur, [82, 5, 14, 18], 2006, 2017] //
        ]],
        [PLATE_TYPE.VANITY, [
            [nevada_sp0_reg, nevada_sp0_blank, nevada_sp0_blur, [82, 5, 14, 18], 2013, undefined, undefined, "Las Vegas Commemorative"], //
            [nevada_sp1_reg, nevada_sp1_blank, nevada_sp1_blur, [82, 5, 14, 18], 2015, undefined, undefined, "Circa 1982"], //
        ]],
    ])],

    [US_STATE_NAMES.CALIFORNIA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [california_reg, california_blank, california_blur, [82, 5, 14, 10, 82, 5, 5, 5], 1993] //
        ]],
        [PLATE_TYPE.VANITY, [
            [california_sp0_reg, california_sp0_blank, california_sp0_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2015, undefined, undefined, "1960s Legacy"], //
            [california_sp1_reg, california_sp1_blank, california_sp1_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2006, undefined, undefined, "Disabled"], //
        ]]
    ])],
    [US_STATE_NAMES.ARIZONA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [arizona_reg, arizona_blank, arizona_blur, [1000,1000, 14, 18], 1997] //
        ]],
        [PLATE_TYPE.VANITY, [
            [arizona_sp0_reg, arizona_sp0_blank, arizona_sp0_blur, [82, 5, 14, 18], 2015, undefined, undefined, "Veterans"] //
        ]],
    ])],
    [US_STATE_NAMES.NEW_MEXICO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [new_mexico_reg, new_mexico_blank, new_mexico_blur, [82, 80, 14, 18], 1991], //
            [new_mexico2_reg, new_mexico2_blank, new_mexico2_blur, [1000,1000, 14, 18], 2010], //
            [new_mexico3_reg, new_mexico3_blank, new_mexico3_blur, [1000,1000, 14, 18], 2017], //
        ]],
        [PLATE_TYPE.OLD, [
            [new_mexico_o0_reg, new_mexico_o0_blank, new_mexico_o0_blur, [1000,1000, 14, 18], 1999, 2010] //
        ]]
    ])],
    [US_STATE_NAMES.TEXAS, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [texas_reg, texas_blank, texas_blur, [1000,1000, 14, 18], 2012], //
        ]],
        [PLATE_TYPE.OLD, [
            [texas_o0_reg, texas_o0_blank, texas_o0_blur, [1000,1000, 14, 18], 2011, 2012], //
            [texas_o1_reg, texas_o1_blank, texas_o1_blur, [1000,1000, 14, 18], 2009, 2011], //
            [texas_o2_reg, texas_o2_blank, texas_o2_blur, [1000,1000, 14, 18], 1999, 2009], //
        ]],
        [PLATE_TYPE.VANITY, [
            [texas_sp0_reg, texas_sp0_blank, texas_sp0_blur, [1000,1000, 14, 18], 2016, undefined, undefined, "Classic Black"], //
        ]]
    ])],
    [US_STATE_NAMES.DISTRICT_OF_COLUMBIA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [district_of_columbia_reg, district_of_columbia_blank, district_of_columbia_blur, [1000,1000, 14, 18], 1998] //
        ]]
    ])],
    [US_STATE_NAMES.LOUISIANA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [louisiana_reg, louisiana_blank, louisiana_blur, [1000,1000, 14, 18], 2016], //
        ]],
        [PLATE_TYPE.OLD, [
            [louisiana_o0_reg, louisiana_o0_blank, louisiana_o0_blur, [1000,1000, 14, 18], 2014, 2016], //
            [louisiana_o1_reg, louisiana_o1_blank, louisiana_o1_blur, [1000,1000, 14, 18], 2011, 2014], //
        ]],
        [PLATE_TYPE.VANITY, [
            [louisiana_sp0_reg, louisiana_sp0_blank, louisiana_sp0_blur, [1000,1000, 14, 18], 1992, undefined, undefined, "LSU"], //
            [louisiana_sp1_reg, louisiana_sp1_blank, louisiana_sp1_blur, [1000,1000, 14, 18], 2010, undefined, undefined, "Saints"], //
            [louisiana_sp2_reg, louisiana_sp2_blank, louisiana_sp2_blur, [1000,1000, 14, 18], 2019, undefined, undefined, "LSU (Purple)"], //
        ]],
    ])],
    [US_STATE_NAMES.MISSISSIPPI, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [mississippi_reg, mississippi_blank, mississippi_blur, [82, 80, 14, 18], 2024], //
        ]],
        [PLATE_TYPE.OLD, [
            [mississippi_o0_reg, mississippi_o0_blank, mississippi_o0_blur, [82, 80, 14, 18], 2019, 2024], //
            [mississippi_o1_reg, mississippi_o1_blank, mississippi_o1_blur, [82, 80, 14, 18], 2012, 2019], //
            [mississippi_o2_reg, mississippi_o2_blank, mississippi_o2_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2009, 2012], //
            [mississippi_o3_reg, mississippi_o3_blank, mississippi_o3_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2003, 2009], //
        ]]
    ])],
    [US_STATE_NAMES.ALABAMA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [alabama_reg, alabama_blank, alabama_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2022], //
            [alabama2_reg, alabama2_blank, alabama2_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2013], //
        ]],
        [PLATE_TYPE.OLD, [
            [alabama_o0_reg, alabama_o0_blank, alabama_o0_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2014, 2022], //
            [alabama_o1_reg, alabama_o1_blank, alabama_o1_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2009, 2014], //
            [alabama_o2_reg, alabama_o2_blank, alabama_o2_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2002, 2009], //
            [alabama2_o2_reg, alabama2_o2_blank, alabama2_o2_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2007, 2013], //
        ]],
        [PLATE_TYPE.VANITY, [
            [alabama_sp0_reg, alabama_sp0_blank, alabama_sp0_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2020, undefined, undefined, "Auburn"], //
            [alabama_sp1_reg, alabama_sp1_blank, alabama_sp1_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2015, undefined, undefined, "University of Alabama"], //
        ]],
    ])],
    [US_STATE_NAMES.GEORGIA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [georgia_reg, georgia_blank, georgia_blur, [82, 80, 14, 18], 2012], //
            [georgia2_reg, georgia2_blank, georgia2_blur, [82, 80, 14, 18], 2012], //
        ]],
    ])],
    [US_STATE_NAMES.SOUTH_CAROLINA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [south_carolina_reg, south_carolina_blank, south_carolina_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2016], //
            [south_carolina2_reg, south_carolina2_blank, south_carolina2_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2016], //
        ]],
        [PLATE_TYPE.OLD, [
            [south_carolina_o0_reg, south_carolina_o0_blank, south_carolina_o0_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2008, 2016], //
            [south_carolina_o1_reg, south_carolina_o1_blank, south_carolina_o1_blur, [82, 80, 14, 18, 82, 80, 5, 80], 1999, 2008], //
            [south_carolina2_o1_reg, south_carolina2_o1_blank, south_carolina2_o1_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2003, 2015], //
        ]]
    ])],
    [US_STATE_NAMES.NORTH_CAROLINA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [north_carolina_reg, north_carolina_blank, north_carolina_blur, [82, 5, 14, 18, 82, 5, 5, 5], 1983], //
            [north_carolina2_reg, north_carolina2_blank, north_carolina2_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2015], //
            [north_carolina3_reg, north_carolina3_blank, north_carolina3_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2019], //
        ]],
        [PLATE_TYPE.OLD, [
            [north_carolina_o0_reg, north_carolina_o0_blank, north_carolina_o0_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2007, 2009], //
        ]]
    ])],
    [US_STATE_NAMES.FLORIDA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [florida_reg, florida_blank, florida_blur, [82, 5, 14, 18], 2003], //
        ]],
        [PLATE_TYPE.VANITY, [
            [florida_sp0_reg, florida_sp0_blank, florida_sp0_blur, [82, 5, 14, 18], 1998, undefined, undefined, "Helping Sea Turtles"], //
            [florida_sp1_reg, florida_sp1_blank, florida_sp1_blur, [82, 5, 14, 18], 2010, undefined, undefined, "Endless Summer"], //
        ]],
    ])],
    [US_STATE_NAMES.ALASKA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [alaska_reg, alaska_blank, alaska_blur, [82, 5, 14, 18, 82, 5, 5, 5], 1981], //
            [alaska2_reg, alaska2_blank, alaska2_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2015], //
            [alaska3_reg, alaska3_blank, alaska3_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2019], //
        ]],
        [PLATE_TYPE.OLD, [
            [alaska_o0_reg, alaska_o0_blank, alaska_o0_blur, [82, 5, 14, 18, 82, 5, 5, 5], 2008, 2010], //
        ]]
    ])],
    [US_STATE_NAMES.HAWAII, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [hawaii_reg, hawaii_blank, hawaii_blur, [82, 5, 14, 18], 1991] //
        ]]
    ])],

    /* U.S. Territories */
    [TERRITORY_NAMES.PUERTO_RICO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [puerto_rico_reg, puerto_rico_blank, puerto_rico_blur, [1000,1000, 14, 18], 1987], //
            [puerto_rico2_reg, puerto_rico2_blank, puerto_rico2_blur, [1000,1000, 14, 18], 2007, 2023], //
        ]],
    ])],
    [TERRITORY_NAMES.AMERICAN_SAMOA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [american_samoa_reg, american_samoa_blank, american_samoa_blur, [1000,1000, 14, 18], 2011] //
        ]],
    ])],
    [TERRITORY_NAMES.GUAM, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [guam_reg, guam_blank, guam_blur, [5, 5, 14, 18, 82, 80, 82, 5], 2009] //
        ]],
    ])],
    [TERRITORY_NAMES.NORTHERN_MARIANA_ISLANDS, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [northern_mariana_islands_reg, northern_mariana_islands_blank, northern_mariana_islands_blur, [5, 5, 14, 18, 82, 80, 82, 5], 2005] //
        ]],
    ])],
    [TERRITORY_NAMES.US_VIRGIN_ISLANDS, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [
            [us_virgin_islands_reg, us_virgin_islands_blank, us_virgin_islands_blur, [1000,1000, 14, 18], 2016] //
        ]],
        [PLATE_TYPE.OLD, [
            [us_virgin_islands_o0_reg, us_virgin_islands_o0_blank, us_virgin_islands_o0_blur, [1000,1000, 14, 18], 2006, 2016] //
        ]],
    ])],

    /* Canada */
    [CANADA_PROVINCE_NAMES.BRITISH_COLUMBIA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[british_columbia_reg, british_columbia_blank, british_columbia_blur, [45, 80, 25, 18, 37, 80], 1986]]] //
    ])],
    [CANADA_PROVINCE_NAMES.YUKON, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[yukon_reg, yukon_blank, yukon_blur, [82, 80, 14, 18, 82, 80, 5, 80], 1990]]] //
    ])],
    [CANADA_PROVINCE_NAMES.ALBERTA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[alberta_reg, alberta_blank, alberta_blur, [5, 80, 14, 18, 5, 5, 82, 80], 1984]]] //
    ])],
    [CANADA_PROVINCE_NAMES.NORTHWEST_TERRITORIES, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[northwest_territories_reg, northwest_territories_blank, northwest_territories_blur, [60, 10, 14, 18], 2010]]], //
        [PLATE_TYPE.OLD, [
            [northwest_territories_o0_reg, northwest_territories_o0_blank, northwest_territories_o0_blur, [40, 80, 14, 18], 1986, 2010] //
        ]]
    ])],
    [CANADA_PROVINCE_NAMES.NUNAVUT, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[nunavut_reg, nunavut_blank, nunavut_blur, [30, 80, 14, 18, 30, 80, 60, 80], 2012]]], //
        [PLATE_TYPE.OLD, [
            [nunavut_o0_reg, nunavut_o0_blank, nunavut_o0_blur, [40, 80, 14, 18, 40, 80, 5, 80], 2000, 2012] //
        ]]
    ])],
    [CANADA_PROVINCE_NAMES.SASKATCHEWAN, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[saskatchewan_reg, saskatchewan_blank, saskatchewan_blur, [82, 80, 14, 18], 2009]]] //
    ])],
    [CANADA_PROVINCE_NAMES.MANITOBA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[manitoba_reg, manitoba_blank, manitoba_blur, [82, 80, 14, 18, 82, 80, 5, 80], 1997]]] //
    ])],
    [CANADA_PROVINCE_NAMES.ONTARIO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[ontario_reg, ontario_blank, ontario_blur, [82, 5, 14, 18], 1996]]], //
        [PLATE_TYPE.OLD, [
            [ontario_o0_reg, ontario_o0_blank, ontario_o0_blur, [82, 5, 14, 18], 2023, 2023] //
        ]]
    ])],
    [CANADA_PROVINCE_NAMES.QUEBEC, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[quebec_reg, quebec_blank, quebec_blur, [5, 80, 14, 18, 5, 5, 82, 80], 1983]]] //
    ])],
    [CANADA_PROVINCE_NAMES.NEW_BRUNSWICK, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[new_brunswick_reg, new_brunswick_blank, new_brunswick_blur, [82, 5, 14, 18], 2011]]], //
        [PLATE_TYPE.OLD, [
            [new_brunswick_o0_reg, new_brunswick_o0_blank, new_brunswick_o0_blur, [82, 5, 14, 18], 1992, 2011] //
        ]]
    ])],
    [CANADA_PROVINCE_NAMES.NOVA_SCOTIA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[nova_scotia_reg, nova_scotia_blank, nova_scotia_blur, [82, 5, 14, 18], 2012]]] //
    ])],
    [CANADA_PROVINCE_NAMES.NEWFOUNDLAND_AND_LABRADOR, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[newfoundland_and_labrador_reg, newfoundland_and_labrador_blank, newfoundland_and_labrador_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2022]]], //
        [PLATE_TYPE.OLD, [
            [newfoundland_and_labrador_o0_reg, newfoundland_and_labrador_o0_blank, newfoundland_and_labrador_o0_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2008, 2022], //
            [newfoundland_and_labrador_o1_reg, newfoundland_and_labrador_o1_blank, newfoundland_and_labrador_o1_blur, [82, 80, 14, 18, 82, 80, 5, 80], 2004, 2008] //
        ]]
    ])],
    [CANADA_PROVINCE_NAMES.PRINCE_EDWARD_ISLAND, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[prince_edward_island_reg, prince_edward_island_blank, prince_edward_island_blur, [82, 5, 14, 18], 2022]]], //
        [PLATE_TYPE.OLD, [
            [prince_edward_island_o0_reg, prince_edward_island_o0_blank, prince_edward_island_o0_blur, [82, 5, 14, 18], 2013, 2022], //
            [prince_edward_island_o1_reg, prince_edward_island_o1_blank, prince_edward_island_o1_blur, [82, 5, 14, 18], 2007, 2013], //
            [prince_edward_island_o2_reg, prince_edward_island_o2_blank, prince_edward_island_o2_blur, [82, 80, 14, 18], 1997, 2007] //
        ]]
    ])],

    /* Mexico */
    [MEXICO_STATE_NAMES.AGUASCALIENTES, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[aguascalientes_reg, aguascalientes_blank, aguascalientes_blur, [1000,1000, 14, 18], 2023]]],
        [PLATE_TYPE.OLD, [
            [aguascalientes_o0_reg, aguascalientes_o0_blank, aguascalientes_o0_blur, [1000,1000, 14, 18], 2017, 2023],
            [aguascalientes_o1_reg, aguascalientes_o1_blank, aguascalientes_o1_blur, [1000,1000, 14, 18], 2012, 2017],
            [aguascalientes_o2_reg, aguascalientes_o2_blank, aguascalientes_o2_blur, [1000,1000, 14, 18], 2005, 2012],
        ]],
    ])],
    [MEXICO_STATE_NAMES.BAJA_CALIFORNIA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[baja_california_reg, baja_california_blank, baja_california_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [baja_california_o0_reg, baja_california_o0_blank, baja_california_o0_blur, [1000,1000, 14, 18], 2020, 2022],
            [baja_california_o1_reg, baja_california_o1_blank, baja_california_o1_blur, [1000,1000, 14, 18], 2017, 2020],
            [baja_california_o2_reg, baja_california_o2_blank, baja_california_o2_blur, [1000,1000, 14, 18], 2014, 2017],
            [baja_california_o3_reg, baja_california_o3_blank, baja_california_o3_blur, [1000,1000, 14, 18], 2012, 2014],
            [baja_california_o4_reg, baja_california_o4_blank, baja_california_o4_blur, [1000,1000, 14, 18], 2010, 2012],
        ]],
    ])],
    [MEXICO_STATE_NAMES.BAJA_CALIFORNIA_SUR, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[baja_california_sur_reg, baja_california_sur_blank, baja_california_sur_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [baja_california_sur_o0_reg, baja_california_sur_o0_blank, baja_california_sur_o0_blur, [1000,1000, 14, 18], 2017, 2022],
            [baja_california_sur_o1_reg, baja_california_sur_o1_blank, baja_california_sur_o1_blur, [1000,1000, 14, 18], 2006, 2017],
        ]],
    ])],
    [MEXICO_STATE_NAMES.CAMPECHE, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[campeche_reg, campeche_blank, campeche_blur, [1000,1000, 14, 18], 2023]]],
        [PLATE_TYPE.OLD, [
            [campeche_o0_reg, campeche_o0_blank, campeche_o0_blur, [1000,1000, 14, 18], 2020, 2023],
            [campeche_o1_reg, campeche_o1_blank, campeche_o1_blur, [1000,1000, 14, 18], 2017, 2020],
            [campeche_o2_reg, campeche_o2_blank, campeche_o2_blur, [1000,1000, 14, 18], 2014, 2017],
            [campeche_o3_reg, campeche_o3_blank, campeche_o3_blur, [1000,1000, 14, 18], 2011, 2014],
            [campeche_o4_reg, campeche_o4_blank, campeche_o4_blur, [1000,1000, 14, 18], 2008, 2011],
        ]],
    ])],
    [MEXICO_STATE_NAMES.CHIHUAHUA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[chihuahua_reg, chihuahua_blank, chihuahua_blur, [1000,1000, 14, 18], 2023]]],
        [PLATE_TYPE.OLD, [
            [chihuahua_o0_reg, chihuahua_o0_blank, chihuahua_o0_blur, [1000,1000, 14, 18], 2022, 2023],
            [chihuahua_o1_reg, chihuahua_o1_blank, chihuahua_o1_blur, [1000,1000, 14, 18], 2017, 2022],
            [chihuahua_o2_reg, chihuahua_o2_blank, chihuahua_o2_blur, [1000,1000, 14, 18], 2016, 2017],
            [chihuahua_o3_reg, chihuahua_o3_blank, chihuahua_o3_blur, [1000,1000, 14, 18], 2015, 2016],
            [chihuahua_o4_reg, chihuahua_o4_blank, chihuahua_o4_blur, [1000,1000, 14, 18], 2012, 2015],
            [chihuahua_o5_reg, chihuahua_o5_blank, chihuahua_o5_blur, [1000,1000, 14, 18], 2009, 2012],
        ]],
    ])],
    [MEXICO_STATE_NAMES.CIUDAD_DE_MEXICO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[ciudad_de_mexico_reg, ciudad_de_mexico_blank, ciudad_de_mexico_blur, [1000,1000, 14, 18], 2019]]],
        [PLATE_TYPE.OLD, [
            [ciudad_de_mexico_o0_reg, ciudad_de_mexico_o0_blank, ciudad_de_mexico_o0_blur, [1000,1000, 14, 18], 2016, 2019],
        ]],
    ])],
    [MEXICO_STATE_NAMES.COAHUILA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[coahuila_reg, coahuila_blank, coahuila_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [coahuila_o0_reg, coahuila_o0_blank, coahuila_o0_blur, [1000,1000, 14, 18], 2019, 2022],
            [coahuila_o1_reg, coahuila_o1_blank, coahuila_o1_blur, [1000,1000, 14, 18], 2017, 2019],
            [coahuila_o2_reg, coahuila_o2_blank, coahuila_o2_blur, [1000,1000, 14, 18], 2016, 2017],
            [coahuila_o3_reg, coahuila_o3_blank, coahuila_o3_blur, [1000,1000, 14, 18], 2013, 2016],
            [coahuila_o4_reg, coahuila_o4_blank, coahuila_o4_blur, [1000,1000, 14, 18], 2010, 2013],
        ]],
    ])],
    [MEXICO_STATE_NAMES.COLIMA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[colima_reg, colima_blank, colima_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [colima_o0_reg, colima_o0_blank, colima_o0_blur, [1000,1000, 14, 18], 2017, 2022],
            [colima_o1_reg, colima_o1_blank, colima_o1_blur, [1000,1000, 14, 18], 2010, 2017],
        ]],
    ])],
    [MEXICO_STATE_NAMES.DISTRITO_FEDERAL, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[distrito_federal_reg, distrito_federal_blank, distrito_federal_blur, [1000,1000, 14, 18], 2013]]],
        [PLATE_TYPE.OLD, [
            [distrito_federal_o0_reg, distrito_federal_o0_blank, distrito_federal_o0_blur, [1000,1000, 14, 18], 2008, 2013],
        ]],
    ])],
    [MEXICO_STATE_NAMES.DURANGO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[durango_reg, durango_blank, durango_blur, [1000,1000, 14, 18], 2023]]],
        [PLATE_TYPE.OLD, [
            [durango_o0_reg, durango_o0_blank, durango_o0_blur, [1000,1000, 14, 18], 2017, 2023],
            [durango_o1_reg, durango_o1_blank, durango_o1_blur, [1000,1000, 14, 18], 2009, 2017],
        ]],
    ])],
    [MEXICO_STATE_NAMES.ESTADO_DE_MEXICO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[estado_de_mexico_reg, estado_de_mexico_blank, estado_de_mexico_blur, [1000,1000, 14, 18], 2024]]],
        [PLATE_TYPE.OLD, [
            [estado_de_mexico_o0_reg, estado_de_mexico_o0_blank, estado_de_mexico_o0_blur, [1000,1000, 14, 18], 2018, 2024],
            [estado_de_mexico_o1_reg, estado_de_mexico_o1_blank, estado_de_mexico_o1_blur, [1000,1000, 14, 18], 2016, 2018],
            [estado_de_mexico_o2_reg, estado_de_mexico_o2_blank, estado_de_mexico_o2_blur, [1000,1000, 14, 18], 2015, 2016],
            [estado_de_mexico_o3_reg, estado_de_mexico_o3_blank, estado_de_mexico_o3_blur, [1000,1000, 14, 18], 2009, 2015],
        ]],
    ])],
    [MEXICO_STATE_NAMES.GUANAJUATO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[guanajuato_reg, guanajuato_blank, guanajuato_blur, [1000,1000, 14, 18], 2020]]],
        [PLATE_TYPE.OLD, [
            [guanajuato_o0_reg, guanajuato_o0_blank, guanajuato_o0_blur, [1000,1000, 14, 18], 2017, 2020],
            [guanajuato_o1_reg, guanajuato_o1_blank, guanajuato_o1_blur, [1000,1000, 14, 18], 2016, 2017],
            [guanajuato_o2_reg, guanajuato_o2_blank, guanajuato_o2_blur, [1000,1000, 14, 18], 2008, 2016],
        ]],
    ])],
    [MEXICO_STATE_NAMES.GUERRERO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[guerrero_reg, guerrero_blank, guerrero_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [guerrero_o0_reg, guerrero_o0_blank, guerrero_o0_blur, [1000,1000, 14, 18], 2018, 2022],
            [guerrero_o1_reg, guerrero_o1_blank, guerrero_o1_blur, [1000,1000, 14, 18], 2016, 2018],
            [guerrero_o2_reg, guerrero_o2_blank, guerrero_o2_blur, [1000,1000, 14, 18], 2015, 2016],
            [guerrero_o3_reg, guerrero_o3_blank, guerrero_o3_blur, [1000,1000, 14, 18], 2012, 2015],
            [guerrero_o4_reg, guerrero_o4_blank, guerrero_o4_blur, [1000,1000, 14, 18], 2009, 2012],
        ]],
    ])],
    [MEXICO_STATE_NAMES.HIDALGO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[hidalgo_reg, hidalgo_blank, hidalgo_blur, [1000,1000, 14, 18], 2023]]],
        [PLATE_TYPE.OLD, [
            [hidalgo_o0_reg, hidalgo_o0_blank, hidalgo_o0_blur, [1000,1000, 14, 18], 2018, 2023],
            [hidalgo_o1_reg, hidalgo_o1_blank, hidalgo_o1_blur, [1000,1000, 14, 18], 2013, 2018],
            [hidalgo_o2_reg, hidalgo_o2_blank, hidalgo_o2_blur, [1000,1000, 14, 18], 2006, 2013],
            [hidalgo_o3_reg, hidalgo_o3_blank, hidalgo_o3_blur, [1000,1000, 14, 18], 2002, 2006],
        ]],
    ])],
    [MEXICO_STATE_NAMES.JALISCO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[jalisco_reg, jalisco_blank, jalisco_blur, [1000,1000, 14, 18], 2019]]],
        [PLATE_TYPE.OLD, [
            [jalisco_o0_reg, jalisco_o0_blank, jalisco_o0_blur, [1000,1000, 14, 18], 2017, 2019],
            [jalisco_o1_reg, jalisco_o1_blank, jalisco_o1_blur, [1000,1000, 14, 18], 2011, 2017],
            [jalisco_o2_reg, jalisco_o2_blank, jalisco_o2_blur, [1000,1000, 14, 18], 2002, 2011],
        ]],
    ])],
    [MEXICO_STATE_NAMES.MICHOACAN, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[michoacan_reg, michoacan_blank, michoacan_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [michoacan_o0_reg, michoacan_o0_blank, michoacan_o0_blur, [1000,1000, 14, 18], 2019, 2022],
            [michoacan_o1_reg, michoacan_o1_blank, michoacan_o1_blur, [1000,1000, 14, 18], 2016, 2019],
            [michoacan_o2_reg, michoacan_o2_blank, michoacan_o2_blur, [1000,1000, 14, 18], 2012, 2016],
            [michoacan_o3_reg, michoacan_o3_blank, michoacan_o3_blur, [1000,1000, 14, 18], 2007, 2012],
        ]],
    ])],
    [MEXICO_STATE_NAMES.MORELOS, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[morelos_reg, morelos_blank, morelos_blur, [1000,1000, 14, 18], 2023]]],
        [PLATE_TYPE.OLD, [
            [morelos_o0_reg, morelos_o0_blank, morelos_o0_blur, [1000,1000, 14, 18], 2019, 2023],
            [morelos_o1_reg, morelos_o1_blank, morelos_o1_blur, [1000,1000, 14, 18], 2013, 2019],
            [morelos_o2_reg, morelos_o2_blank, morelos_o2_blur, [1000,1000, 14, 18], 2008, 2013],
        ]],
    ])],
    [MEXICO_STATE_NAMES.NAYARIT, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[nayarit_reg, nayarit_blank, nayarit_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [nayarit_o0_reg, nayarit_o0_blank, nayarit_o0_blur, [1000,1000, 14, 18], 2021, 2022],
            [nayarit_o1_reg, nayarit_o1_blank, nayarit_o1_blur, [1000,1000, 14, 18], 2017, 2021],
            [nayarit_o2_reg, nayarit_o2_blank, nayarit_o2_blur, [1000,1000, 14, 18], 2016, 2017],
            [nayarit_o3_reg, nayarit_o3_blank, nayarit_o3_blur, [1000,1000, 14, 18], 2013, 2016],
            [nayarit_o4_reg, nayarit_o4_blank, nayarit_o4_blur, [1000,1000, 14, 18], 2010, 2013],
        ]],
    ])],
    [MEXICO_STATE_NAMES.NUEVO_LEON, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[nuevo_leon_reg, nuevo_leon_blank, nuevo_leon_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [nuevo_leon_o0_reg, nuevo_leon_o0_blank, nuevo_leon_o0_blur, [1000,1000, 14, 18], 2016, 2022],
            [nuevo_leon_o1_reg, nuevo_leon_o1_blank, nuevo_leon_o1_blur, [1000,1000, 14, 18], 2011, 2016],
            [nuevo_leon_o2_reg, nuevo_leon_o2_blank, nuevo_leon_o2_blur, [1000,1000, 14, 18], 2008, 2011],
        ]],
    ])],
    [MEXICO_STATE_NAMES.OAXACA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[oaxaca_reg, oaxaca_blank, oaxaca_blur, [1000,1000, 14, 18], 2023]]],
        [PLATE_TYPE.OLD, [
            [oaxaca_o0_reg, oaxaca_o0_blank, oaxaca_o0_blur, [1000,1000, 14, 18], 2018, 2023],
            [oaxaca_o1_reg, oaxaca_o1_blank, oaxaca_o1_blur, [1000,1000, 14, 18], 2013, 2018],
            [oaxaca_o2_reg, oaxaca_o2_blank, oaxaca_o2_blur, [1000,1000, 14, 18], 2009, 2013],
        ]],
    ])],
    [MEXICO_STATE_NAMES.PUEBLA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[puebla_reg, puebla_blank, puebla_blur, [1000,1000, 14, 18], 2020]]],
        [PLATE_TYPE.OLD, [
            [puebla_o0_reg, puebla_o0_blank, puebla_o0_blur, [1000,1000, 14, 18], 2019, 2020],
            [puebla_o1_reg, puebla_o1_blank, puebla_o1_blur, [1000,1000, 14, 18], 2011, 2019],
            [puebla_o2_reg, puebla_o2_blank, puebla_o2_blur, [1000,1000, 14, 18], 2010, 2011],
        ]],
    ])],
    [MEXICO_STATE_NAMES.QUERETARO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[queretaro_reg, queretaro_blank, queretaro_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [queretaro_o0_reg, queretaro_o0_blank, queretaro_o0_blur, [1000,1000, 14, 18], 2017, 2022],
            [queretaro_o1_reg, queretaro_o1_blank, queretaro_o1_blur, [1000,1000, 14, 18], 2008, 2017],
        ]],
    ])],
    [MEXICO_STATE_NAMES.QUINTANA_ROO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[quintana_roo_reg, quintana_roo_blank, quintana_roo_blur, [1000,1000, 14, 18], 2023]]],
        [PLATE_TYPE.OLD, [
            [quintana_roo_o0_reg, quintana_roo_o0_blank, quintana_roo_o0_blur, [1000,1000, 14, 18], 2020, 2023],
            [quintana_roo_o1_reg, quintana_roo_o1_blank, quintana_roo_o1_blur, [1000,1000, 14, 18], 2017, 2020],
            [quintana_roo_o2_reg, quintana_roo_o2_blank, quintana_roo_o2_blur, [1000,1000, 14, 18], 2014, 2017],
            [quintana_roo_o3_reg, quintana_roo_o3_blank, quintana_roo_o3_blur, [1000,1000, 14, 18], 2011, 2014],
            [quintana_roo_o4_reg, quintana_roo_o4_blank, quintana_roo_o4_blur, [1000,1000, 14, 18], 2007, 2011],
        ]],
    ])],
    [MEXICO_STATE_NAMES.SAN_LUIS_POTOSI, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[san_luis_potosi_reg, san_luis_potosi_blank, san_luis_potosi_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [san_luis_potosi_o0_reg, san_luis_potosi_o0_blank, san_luis_potosi_o0_blur, [1000,1000, 14, 18], 2016, 2022],
            [san_luis_potosi_o1_reg, san_luis_potosi_o1_blank, san_luis_potosi_o1_blur, [1000,1000, 14, 18], 2013, 2016],
            [san_luis_potosi_o2_reg, san_luis_potosi_o2_blank, san_luis_potosi_o2_blur, [1000,1000, 14, 18], 2010, 2013],
        ]],
    ])],
    [MEXICO_STATE_NAMES.SINALOA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[sinaloa_reg, sinaloa_blank, sinaloa_blur, [1000,1000, 14, 18], 2021]]],
        [PLATE_TYPE.OLD, [
            [sinaloa_o0_reg, sinaloa_o0_blank, sinaloa_o0_blur, [1000,1000, 14, 18], 2017, 2021],
            [sinaloa_o1_reg, sinaloa_o1_blank, sinaloa_o1_blur, [1000,1000, 14, 18], 2012, 2017],
            [sinaloa_o2_reg, sinaloa_o2_blank, sinaloa_o2_blur, [1000,1000, 14, 18], 2006, 2012],
        ]],
    ])],
    [MEXICO_STATE_NAMES.SONORA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[sonora_reg, sonora_blank, sonora_blur, [1000,1000, 14, 18], 2014]]],
        [PLATE_TYPE.OLD, [
            [sonora_o0_reg, sonora_o0_blank, sonora_o0_blur, [1000,1000, 14, 18], 2011, 2014],
            [sonora_o1_reg, sonora_o1_blank, sonora_o1_blur, [1000,1000, 14, 18], 2008, 2011],
        ]],
    ])],
    [MEXICO_STATE_NAMES.TABASCO, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[tabasco_reg, tabasco_blank, tabasco_blur, [1000,1000, 14, 18], 2020]]],
        [PLATE_TYPE.OLD, [
            [tabasco_o0_reg, tabasco_o0_blank, tabasco_o0_blur, [1000,1000, 14, 18], 2017, 2020],
            [tabasco_o1_reg, tabasco_o1_blank, tabasco_o1_blur, [1000,1000, 14, 18], 2014, 2017],
            [tabasco_o2_reg, tabasco_o2_blank, tabasco_o2_blur, [1000,1000, 14, 18], 2009, 2014],
        ]],
    ])],
    [MEXICO_STATE_NAMES.TAMAULIPAS, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[tamaulipas_reg, tamaulipas_blank, tamaulipas_blur, [1000,1000, 14, 18], 2023]]],
        [PLATE_TYPE.OLD, [
            [tamaulipas_o0_reg, tamaulipas_o0_blank, tamaulipas_o0_blur, [1000,1000, 14, 18], 2022, 2023],
            [tamaulipas_o1_reg, tamaulipas_o1_blank, tamaulipas_o1_blur, [1000,1000, 14, 18], 2019, 2022],
            [tamaulipas_o2_reg, tamaulipas_o2_blank, tamaulipas_o2_blur, [1000,1000, 14, 18], 2016, 2019],
            [tamaulipas_o3_reg, tamaulipas_o3_blank, tamaulipas_o3_blur, [1000,1000, 14, 18], 2013, 2016],
            [tamaulipas_o4_reg, tamaulipas_o4_blank, tamaulipas_o4_blur, [1000,1000, 14, 18], 2010, 2013],
        ]],
    ])],
    [MEXICO_STATE_NAMES.TLAXCALA, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[tlaxcala_reg, tlaxcala_blank, tlaxcala_blur, [1000,1000, 14, 18], 2023]]],
        [PLATE_TYPE.OLD, [
            [tlaxcala_o0_reg, tlaxcala_o0_blank, tlaxcala_o0_blur, [1000,1000, 14, 18], 2020, 2023],
            [tlaxcala_o1_reg, tlaxcala_o1_blank, tlaxcala_o1_blur, [1000,1000, 14, 18], 2017, 2020],
            [tlaxcala_o2_reg, tlaxcala_o2_blank, tlaxcala_o2_blur, [1000,1000, 14, 18], 2015, 2017],
            [tlaxcala_o3_reg, tlaxcala_o3_blank, tlaxcala_o3_blur, [1000,1000, 14, 18], 2012, 2015],
            [tlaxcala_o4_reg, tlaxcala_o4_blank, tlaxcala_o4_blur, [1000,1000, 14, 18], 2006, 2012],
        ]],
    ])],
    [MEXICO_STATE_NAMES.VERACRUZ, new Map<PLATE_TYPE, PLATE_TUPLE[]>([

        [PLATE_TYPE.REGULAR, [[veracruz_reg, veracruz_blank, veracruz_blur, [1000,1000, 14, 18], 2019]]],
        [PLATE_TYPE.OLD, [
            [veracruz_o0_reg, veracruz_o0_blank, veracruz_o0_blur, [1000,1000, 14, 18], 2017, 2019],
            [veracruz_o1_reg, veracruz_o1_blank, veracruz_o1_blur, [1000,1000, 14, 18], 2011, 2017],
            [veracruz_o2_reg, veracruz_o2_blank, veracruz_o2_blur, [1000,1000, 14, 18], 2008, 2011],
        ]],
    ])],
    [MEXICO_STATE_NAMES.YUCATAN, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[yucatan_reg, yucatan_blank, yucatan_blur, [1000,1000, 14, 18], 2020]]],
        [PLATE_TYPE.OLD, [
            [yucatan_o0_reg, yucatan_o0_blank, yucatan_o0_blur, [1000,1000, 14, 18], 2017, 2020],
            [yucatan_o1_reg, yucatan_o1_blank, yucatan_o1_blur, [1000,1000, 14, 18], 2013, 2017],
            [yucatan_o2_reg, yucatan_o2_blank, yucatan_o2_blur, [1000,1000, 14, 18], 2009, 2013],
        ]],
    ])],
    [MEXICO_STATE_NAMES.ZACATECAS, new Map<PLATE_TYPE, PLATE_TUPLE[]>([
        [PLATE_TYPE.REGULAR, [[zacatecas_reg, zacatecas_blank, zacatecas_blur, [1000,1000, 14, 18], 2022]]],
        [PLATE_TYPE.OLD, [
            [zacatecas_o0_reg, zacatecas_o0_blank, zacatecas_o0_blur, [1000,1000, 14, 18], 2017, 2022],
            [zacatecas_o1_reg, zacatecas_o1_blank, zacatecas_o1_blur, [1000,1000, 14, 18], 2011, 2017],
            [zacatecas_o2_reg, zacatecas_o2_blank, zacatecas_o2_blur, [1000,1000, 14, 18], 2008, 2011],
        ]],
    ])]

]);


